// stickyFooter is not defined in mobile
function safeStickyFooter() {
    if (typeof stickyFooter === 'function') {
        stickyFooter();
    }
}

// Returns addressString with its last comma and following text removed
function removeStateZipFromAddress(addressString) {
    return addressString.replace(/,[^,]*$/, '');
}

//This is all in here so that we don't have any global variables
function initInteractiveMap() {
    // community-map.js can load when hasMapPlaces is true even if the Explore the Area partial (and its globals) is not on the page
    if (typeof mapConfig === 'undefined') {
        return;
    }
    var $html = $('html'),
        $mapResultsWrapper = $('.communityMap .map-results-wrapper'),
        $communityMap = $mapResultsWrapper.find('#communityMap'),
        $mapSearch = $('.communityMap .map-info .map-search-filters'),
        $mapResults = $mapResultsWrapper.find('.map-search-results'),
        $mapResultsListing = $mapResults.find('.map-results-listing'),
        $resetSearchBtn = $('.communityMap .map-search-actions .btn.reset-search'),
        $poiSelect = $mapSearch.find('.poi-select'),
        $keywordSearch = $mapSearch.find('input.keyword'),
        $noResults = $mapResults.find('.map-search-no-results'),
        $mapResultsDisplayStatus = $mapResultsWrapper.find('#map-results-display-status'),
        $featuredPois,
        mapInfo = document.getElementById('explore-area-map-info'),
        changeMapViewButton = document.getElementById('change-map-view-button'),
        isMapView = true,
        poiDisplayLabel = document.getElementById('poi-display-label'),
        isMobile = isMobilePage(),
        hasFeaturedLocation =
            typeof featuredLocations !== 'undefined' && featuredLocations != null && featuredLocations.length > 0,
        selectedMarker = { marker: null, typeName: null },
        selectedMarkerInfoBoxMobile = document.getElementById('selected-marker-info-box'),
        initialized = false,
        initializedSearchable = false,
        poiCount = 0,
        poiMarkers = [],
        poiResultsMap = {},
        placesIdMap = {},
        keywordMarkers = [],
        placesRetryQueue = [],
        gMap,
        communityMarker,
        infowindow,
        lat,
        lng,
        poiUpdateThrottle,
        mapViewChangeThrottle,
        KEYWORD_SEARCH_POI_ID = 'keyword-search',
        GA_EVENT_CATEGORY = 'Community Map',
        GA_GENERIC_EVENT_LABEL = 'Map V1',
        POI_UPDATE_TIMEOUT = 500,
        MAP_VIEW_CHANGE_THROTTLE_TIME = 150,
        INITIAL_ZOOM_LEVEL = 14,
        FEATURED_LOCATION_POI = {
            display: 'Featured',
            keyword: 'featured',
            isGroup: false,
        },
        GENERIC_MARKER_ICON_PATH =
            'M6.19554 1.5C3.72108 1.5 1.5 3.36259 1.5 6.05256C1.5 6.40222 1.62112 6.99829 1.89156 7.80332C2.15557 8.58922 2.54112 9.51457 3.0204 10.4982C3.87305 12.2482 5.00375 14.1449 6.23209 15.7334C7.6145 14.1456 8.76316 12.251 9.59073 10.5008C10.0526 9.524 10.409 8.60361 10.6485 7.8208C10.8926 7.02324 11 6.41736 11 6.05256C11 3.3976 8.49109 1.5 6.19554 1.5ZM0 6.05256C0 2.42459 3.00664 0 6.19554 0C9.12772 0 12.5 2.38958 12.5 6.05256C12.5 6.63951 12.3419 7.41321 12.0829 8.2597C11.8194 9.12095 11.4352 10.1091 10.9468 11.1419C9.97231 13.2028 8.56139 15.4874 6.81527 17.3207C6.46728 17.686 5.87503 17.6714 5.54808 17.2782C4.04607 15.4718 2.6716 13.207 1.67194 11.1552C1.17126 10.1277 0.758734 9.14154 0.469647 8.28099C0.186987 7.43957 0 6.65418 0 6.05256Z',
        GENERIC_MARKER_ICON_PATH2 =
            'M6.25026 7.31644C6.83936 7.31644 7.31693 6.83888 7.31693 6.24977C7.31693 5.66067 6.83936 5.18311 6.25026 5.18311C5.66116 5.18311 5.18359 5.66067 5.18359 6.24977C5.18359 6.83888 5.66116 7.31644 6.25026 7.31644ZM6.25026 8.81644C7.66779 8.81644 8.81693 7.6673 8.81693 6.24977C8.81693 4.83224 7.66779 3.68311 6.25026 3.68311C4.83273 3.68311 3.68359 4.83224 3.68359 6.24977C3.68359 7.6673 4.83273 8.81644 6.25026 8.81644Z',
        DEFAULT_INFO_BUBBLE_OPTIONS = {
            arrowStyle: 0,
            backgroundClassName: 'info-bubble color-primary',
            backgroundColor: 'rgba(255,255,255,.75)',
            hideCloseButton: true,
            borderWidth: 0,
            shadowStyle: 3,
            borderColor: 'rgba(76, 76, 76, 0.65)',
            borderRadius: 0,
            arrowSize: 10,
            arrowPosition: '50%',
            minWidth: 160,
        },
        RESULTS_DISPLAY_OPENED = 'Map results listing display opened. Press to close.',
        RESULTS_DISPLAY_CLOSED = 'Map results listing display closed. Press to open.',
        NO_RESULTS_NO_SEARCH_SELECTED = 'No category selected.',
        NO_RESULTS_FOUND = 'No results found.';

    const LOCATION_MARKER_SIZE = new google.maps.Size(36, 48);
    const GENERIC_MARKER_SIZE = new google.maps.Size(28, 38);

    const GENERIC_MARKER_MAP_ICON = 'generic2.png';

    /**
     * Returns given point of interest's icon given the color in an svg format.
     * NOTE: Changing the scale will affect the point set in the anchor
     * Fill rule does not work on the map.
     * For stroke based paths, fill with white on the map.
     */
    function getPOIIcon(pointOfInterest, color, onlySVG, size, isHover, isSelected) {
        let SVGElement;
        let mapIcon;

        let width = 18,
            height = 18;
        const anchor = new google.maps.Point(12, 12);

        if (!!pointOfInterest) {
            switch (pointOfInterest.toLowerCase()) {
                case 'dog parks':
                    const dogParkSVGPath1 =
                        'M11.8452 15.6023C11.8453 15.6839 11.9111 15.7497 11.9927 15.7498C12.0743 15.7498 12.1401 15.6839 12.1401 15.6023V9.70874C12.1401 9.11589 12.293 8.53271 12.5825 8.01538L12.8892 7.46753L12.9019 7.44507L12.9155 7.42358C13.2622 6.89263 13.8431 6.59795 14.436 6.57202C15.5432 6.52379 15.84 6.33188 15.8911 6.28687C15.9004 6.22978 15.8954 6.19327 15.895 6.02319C15.8862 6.00766 15.8394 5.91321 15.6235 5.76245C15.3606 5.57882 14.9865 5.41774 14.6177 5.32593C13.877 5.14156 13.4822 4.41676 13.4595 3.823C13.4522 3.63273 13.3803 3.49091 13.2964 3.40015C13.2058 3.3023 13.1221 3.28186 13.0962 3.28101C12.8822 3.27458 12.6043 3.23337 12.3452 3.12573C12.1732 3.05422 11.9116 2.90933 11.7368 2.64331C11.8319 3.66983 11.6101 4.70203 11.0982 5.59937C10.4571 6.72295 9.26283 7.41659 7.96925 7.41675H4.65089C3.90417 7.41675 3.19752 7.11354 2.68507 6.5896L3.13917 7.72144L3.14796 7.7439L3.15577 7.76733C3.32276 8.27883 3.35596 8.91592 3.35596 9.16675C3.35596 9.41383 3.28139 9.64757 3.20948 9.82495C3.13275 10.0142 3.03109 10.2057 2.92432 10.3855C2.71045 10.7457 2.44286 11.1138 2.21046 11.4089C2.08008 11.5745 2.00299 11.7542 1.98097 11.9285L1.5005 15.7292C1.50004 15.7331 1.5005 15.7361 1.5005 15.7361C1.5005 15.7361 1.50291 15.7411 1.50538 15.7439C1.50763 15.7464 1.51124 15.7488 1.51124 15.7488C1.51124 15.7488 1.51423 15.7497 1.51905 15.7498C1.52762 15.7498 1.53543 15.7444 1.53761 15.7361L2.33448 12.616C2.37069 12.4743 2.43648 12.2852 2.57081 12.1042L2.71729 11.9255C3.08206 11.5235 3.58647 11.2231 3.99561 11.0203C4.82716 10.6081 5.72309 10.8222 6.32764 11.0291C7.4682 11.4193 9.24247 11.6329 10.5005 11.7175C11.2416 11.7674 11.8452 12.3785 11.8452 13.1462V15.6023ZM13.6401 15.6023C13.6401 16.5124 12.9027 17.2498 11.9927 17.2498C11.0827 17.2497 10.3453 16.5123 10.3452 15.6023V13.2087C9.06911 13.1203 7.16278 12.8998 5.84229 12.448C5.29881 12.262 4.91726 12.2373 4.66163 12.364C4.25835 12.5639 3.94214 12.7866 3.78956 12.9792C3.78892 12.9815 3.78835 12.9841 3.78761 12.9871L2.99073 16.1072C2.81892 16.7796 2.21307 17.2498 1.51905 17.2498C0.604667 17.2497 -0.10244 16.4479 0.012215 15.5408L0.492684 11.74C0.553135 11.2617 0.755198 10.8314 1.03175 10.4802C1.2419 10.2134 1.46636 9.90266 1.63429 9.61987C1.71833 9.47832 1.78006 9.3571 1.81886 9.26147C1.84503 9.19692 1.85279 9.16228 1.85499 9.15308C1.85432 9.0674 1.8488 8.9114 1.82862 8.73511C1.80742 8.55003 1.7734 8.37486 1.73194 8.2439L0.417488 4.96265C0.206177 4.43529 0.384417 3.83176 0.848152 3.50366L0.956551 3.4353C1.47073 3.14592 2.12182 3.26525 2.49952 3.71851L2.57569 3.82104L3.61378 5.36401C3.846 5.70942 4.23467 5.91675 4.65089 5.91675H7.96925C8.72416 5.91659 9.42127 5.51189 9.79542 4.8562C10.1705 4.19881 10.3241 3.43775 10.2339 2.68628L10.1548 2.02612C10.1202 1.73779 10.2164 1.44852 10.4175 1.23901L10.5405 1.11108C11.0352 0.596016 11.8104 0.468777 12.4439 0.798584C12.6508 0.906366 12.8084 1.08803 12.8862 1.30542L12.9146 1.40112L13.0005 1.76245C13.0068 1.76383 13.0132 1.76701 13.02 1.76831C13.0636 1.77663 13.1065 1.78094 13.1411 1.78198C14.1085 1.81108 14.9174 2.68858 14.9585 3.76538C14.9588 3.77319 14.9603 3.78914 14.9673 3.80933C14.9742 3.82919 14.9843 3.84737 14.9946 3.86206C14.9988 3.86797 15.0022 3.87326 15.0054 3.87671C15.5102 4.00534 16.0492 4.23074 16.4819 4.53296C16.8787 4.81003 17.3949 5.30148 17.395 5.99976C17.395 6.13989 17.4771 6.82733 16.9546 7.34741C16.4817 7.81796 15.673 8.01903 14.5015 8.07007C14.3538 8.07654 14.2381 8.14738 14.1763 8.23706L13.8911 8.7478C13.7269 9.04128 13.6401 9.37242 13.6401 9.70874V15.6023Z';
                    const dogParkSVGPath2 =
                        'M13.4724 7.90407L10.2724 5.57073L10.8615 4.76273L14.0615 7.09606L13.4724 7.90407ZM12.5124 8.90407L9.31237 6.57073L9.90154 5.76272L13.1015 8.09606L12.5124 8.90407Z';
                    const dogParkSVGPath3 =
                        'M0.203504 0.269136C0.331064 0.0242211 0.633014 -0.0709139 0.877929 0.0566458L10.4779 5.05665L10.016 5.94356L0.415994 0.94356C0.17108 0.816 0.0759447 0.51405 0.203504 0.269136Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, dogParkSVGPath1) +
                            getPOISVGPath(color, dogParkSVGPath2, true) +
                            getPOISVGPath(color, dogParkSVGPath3, true),
                    );
                    mapIcon = 'dog-park.png';
                    break;
                case 'city parks':
                case 'parks':
                    const parksSvgPath1 =
                        'M5.45737 13.335L6.03223 12.8533L6.03223 12.8533L5.45737 13.335ZM0.892595 7.88744L0.317736 8.36914H0.317736L0.892595 7.88744ZM3.79928 16.3921L4.05293 15.6863H4.05293L3.79928 16.3921ZM5.39521 16.6766L5.38385 17.4266H5.38385L5.39521 16.6766ZM9.04263 13.335L8.46777 12.8533L8.46777 12.8533L9.04263 13.335ZM13.6074 7.88744L14.1823 8.36914V8.36914L13.6074 7.88744ZM10.7007 16.3921L10.4471 15.6863H10.4471L10.7007 16.3921ZM9.10479 16.6766L9.11615 17.4266H9.11615L9.10479 16.6766ZM4.34361 0.811803L5.02688 1.12106V1.12106L4.34361 0.811803ZM10.0538 0.789216L9.40235 1.1608V1.1608L10.0538 0.789216ZM9.91912 0.790031L9.27854 0.399961V0.399962L9.91912 0.790031ZM8.59283 2.9681L9.23341 3.35817V3.35817L8.59283 2.9681ZM8.45274 2.96338L7.78858 3.3118L7.78858 3.3118L8.45274 2.96338ZM7.40744 0.970857L8.0716 0.622435L8.0716 0.622434L7.40744 0.970857ZM7.26886 0.963745L7.89603 1.37503L7.89603 1.37503L7.26886 0.963745ZM5.94455 2.98319L5.31738 2.57191V2.57191L5.94455 2.98319ZM5.80864 2.9808L5.16806 3.37087L5.16806 3.37087L5.80864 2.9808ZM4.48352 0.804617L5.1241 0.414551V0.414551L4.48352 0.804617ZM6.5 17.0982C6.5 17.5125 6.83578 17.8482 7.25 17.8482C7.66421 17.8482 8 17.5125 8 17.0982H7.25H6.5ZM5.45737 13.335L6.03223 12.8533L1.46745 7.40574L0.892595 7.88744L0.317736 8.36914L4.88251 13.8167L5.45737 13.335ZM0.75 7.94266H0V8.8452H0.75H1.5V7.94266H0.75ZM3.79928 16.3921L3.54563 17.0979C4.09684 17.296 4.70989 17.4164 5.38385 17.4266L5.39521 16.6766L5.40656 15.9267C4.90009 15.9191 4.45065 15.8292 4.05293 15.6863L3.79928 16.3921ZM5.47727 16.5931H6.22727V13.3902H5.47727H4.72727V16.5931H5.47727ZM5.39521 16.6766L5.38385 17.4266C5.87031 17.4339 6.22727 17.0349 6.22727 16.5931H5.47727H4.72727C4.72727 16.2443 5.00984 15.9207 5.40656 15.9267L5.39521 16.6766ZM0.75 8.8452H0C0 10.3491 0.0801461 12.0854 0.536393 13.5892C0.996087 15.1043 1.87681 16.4982 3.54563 17.0979L3.79928 16.3921L4.05293 15.6863C3.00027 15.308 2.35635 14.4212 1.97178 13.1537C1.58375 11.8748 1.5 10.3267 1.5 8.8452H0.75ZM0.892595 7.88744L1.46745 7.40574C0.92947 6.76371 0 7.22517 0 7.94266H0.75H1.5C1.5 8.50432 0.757137 8.89352 0.317736 8.36914L0.892595 7.88744ZM5.45737 13.335L4.8825 13.8167C4.78035 13.6948 4.72727 13.5432 4.72727 13.3902H5.47727H6.22727C6.22727 13.1967 6.16006 13.0058 6.03223 12.8533L5.45737 13.335ZM9.04263 13.335L9.61749 13.8167L14.1823 8.36914L13.6074 7.88744L13.0325 7.40574L8.46777 12.8533L9.04263 13.335ZM13.75 7.94266H13V8.8452H13.75H14.5V7.94266H13.75ZM10.7007 16.3921L10.4471 15.6863C10.0493 15.8292 9.59991 15.9191 9.09344 15.9267L9.10479 16.6766L9.11615 17.4266C9.79011 17.4164 10.4032 17.296 10.9544 17.0979L10.7007 16.3921ZM9.02273 16.5931H9.77273V13.3902H9.02273H8.27273V16.5931H9.02273ZM9.10479 16.6766L9.09344 15.9267C9.49015 15.9207 9.77273 16.2443 9.77273 16.5931H9.02273H8.27273C8.27273 17.0349 8.6297 17.4339 9.11615 17.4266L9.10479 16.6766ZM13.75 8.8452H13C13 10.3267 12.9162 11.8748 12.5282 13.1537C12.1436 14.4212 11.4997 15.308 10.4471 15.6863L10.7007 16.3921L10.9544 17.0979C12.6232 16.4982 13.5039 15.1043 13.9636 13.5892C14.4199 12.0854 14.5 10.3491 14.5 8.8452H13.75ZM13.6074 7.88744L14.1823 8.36914C13.7429 8.89352 13 8.50432 13 7.94266H13.75H14.5C14.5 7.22517 13.5705 6.76371 13.0325 7.40574L13.6074 7.88744ZM9.04263 13.335L8.46777 12.8533C8.33995 13.0058 8.27273 13.1967 8.27273 13.3902H9.02273H9.77273C9.77273 13.5432 9.71964 13.6948 9.6175 13.8167L9.04263 13.335ZM4.34361 0.811803L3.66033 0.502549C2.90621 2.16872 2.4181 4.53157 2.7822 6.53363C2.96621 7.54539 3.37875 8.51958 4.14445 9.24374C4.92221 9.97929 5.99089 10.3872 7.34378 10.3872V9.6372V8.8872C6.30758 8.8872 5.62944 8.58357 5.17513 8.15392C4.70877 7.71287 4.40402 7.06817 4.25799 6.26523C3.96203 4.63788 4.36292 2.58803 5.02688 1.12106L4.34361 0.811803ZM7.34378 9.6372V10.3872C8.72011 10.3872 9.78356 9.92132 10.5312 9.11608C11.2599 8.33127 11.6242 7.29421 11.7663 6.25057C12.0475 4.18496 11.4978 1.80707 10.7053 0.417629L10.0538 0.789216L9.40235 1.1608C10.0338 2.26782 10.5161 4.31392 10.28 6.04818C10.1634 6.90448 9.88151 7.61133 9.43201 8.09544C9.00146 8.55914 8.35459 8.8872 7.34378 8.8872V9.6372ZM9.91912 0.790031L9.27854 0.399962L7.95225 2.57803L8.59283 2.9681L9.23341 3.35817L10.5597 1.1801L9.91912 0.790031ZM8.45274 2.96338L9.11689 2.61496L8.0716 0.622435L7.40744 0.970857L6.74329 1.31928L7.78858 3.3118L8.45274 2.96338ZM7.26886 0.963745L6.64169 0.55246L5.31738 2.57191L5.94455 2.98319L6.57172 3.39448L7.89603 1.37503L7.26886 0.963745ZM5.80864 2.9808L6.44923 2.59073L5.1241 0.414551L4.48352 0.804617L3.84293 1.19468L5.16806 3.37087L5.80864 2.9808ZM7.40744 0.970857L8.0716 0.622434C7.77926 0.06519 6.99235 0.0177394 6.64169 0.55246L7.26886 0.963745L7.89603 1.37503C7.61377 1.80546 6.97751 1.76574 6.74329 1.31928L7.40744 0.970857ZM8.59283 2.9681L7.95225 2.57803C8.22424 2.13136 8.87733 2.1583 9.11689 2.61496L8.45274 2.96338L7.78858 3.3118C8.08743 3.88146 8.89519 3.91361 9.23341 3.35817L8.59283 2.9681ZM10.0538 0.789216L10.7053 0.41763C10.366 -0.177271 9.57999 -0.0950891 9.27854 0.399961L9.91912 0.790031L10.5597 1.1801C10.322 1.57044 9.68087 1.64912 9.40235 1.1608L10.0538 0.789216ZM5.94455 2.98319L5.31738 2.57191C5.58748 2.16003 6.19479 2.17288 6.44923 2.59073L5.80864 2.9808L5.16806 3.37087C5.48499 3.89134 6.23581 3.90672 6.57172 3.39448L5.94455 2.98319ZM4.34361 0.811803L5.02688 1.12106C4.79365 1.63636 4.1076 1.62933 3.84293 1.19468L4.48352 0.804617L5.1241 0.414551C4.79159 -0.131513 3.94755 -0.132035 3.66033 0.50255L4.34361 0.811803ZM7.25 9.5193H6.5V17.0982H7.25H8V9.5193H7.25Z';
                    width = 15;
                    SVGElement = getPOISVGElement(width, height, getPOISVGPath(color, parksSvgPath1));
                    mapIcon = 'park1.png';
                    break;
                case 'bus stations':
                case 'public transportation':
                    const busSvgPath1 =
                        'M3.80554 6.11365V6.97728H11.6944V6.11365H3.80554ZM2.80554 4.61365C2.5294 4.61365 2.30554 4.8375 2.30554 5.11365V7.97728C2.30554 8.25343 2.5294 8.47728 2.80554 8.47728H12.6944C12.9706 8.47728 13.1944 8.25343 13.1944 7.97728V5.11365C13.1944 4.83751 12.9706 4.61365 12.6944 4.61365H2.80554Z';
                    const busSvgPath2 =
                        'M3.8611 12.1136C4.17407 12.1136 4.41665 11.8633 4.41665 11.5682C4.41665 11.2731 4.17407 11.0227 3.8611 11.0227C3.54812 11.0227 3.30554 11.2731 3.30554 11.5682C3.30554 11.8633 3.54812 12.1136 3.8611 12.1136ZM3.8611 13.1136C4.72021 13.1136 5.41665 12.4217 5.41665 11.5682C5.41665 10.7147 4.72021 10.0227 3.8611 10.0227C3.00199 10.0227 2.30554 10.7147 2.30554 11.5682C2.30554 12.4217 3.00199 13.1136 3.8611 13.1136Z';
                    const busSvgPath3 =
                        'M11.6389 12.1136C11.9519 12.1136 12.1944 11.8633 12.1944 11.5682C12.1944 11.2731 11.9519 11.0227 11.6389 11.0227C11.3259 11.0227 11.0833 11.2731 11.0833 11.5682C11.0833 11.8633 11.3259 12.1136 11.6389 12.1136ZM11.6389 13.1136C12.498 13.1136 13.1944 12.4217 13.1944 11.5682C13.1944 10.7147 12.498 10.0227 11.6389 10.0227C10.7798 10.0227 10.0833 10.7147 10.0833 11.5682C10.0833 12.4217 10.7798 13.1136 11.6389 13.1136Z';
                    const busSvgPath4 =
                        'M0 4.75C0 2.12665 2.12665 0 4.75 0H10.75C13.3734 0 15.5 2.12665 15.5 4.75V14.65C15.5 15.1194 15.1194 15.5 14.65 15.5H0.85C0.380552 15.5 0 15.1194 0 14.65V4.75ZM4.75 1.5C2.95507 1.5 1.5 2.95507 1.5 4.75V14H14V4.75C14 2.95507 12.5449 1.5 10.75 1.5H4.75Z';
                    const busSvgPath5 =
                        'M1.54427 16.9318C1.53344 16.8729 1.52778 16.8121 1.52778 16.75V15.4318H4.63889V16.75C4.63889 16.8121 4.63323 16.8729 4.6224 16.9318C4.5369 17.3973 4.12908 17.75 3.63889 17.75H2.52778C2.03758 17.75 1.62977 17.3973 1.54427 16.9318Z';
                    const busSvgPath6 =
                        'M10.8776 16.9318C10.8668 16.8729 10.8611 16.8121 10.8611 16.75V15.4318H13.9722V16.75C13.9722 16.8121 13.9666 16.8729 13.9557 16.9318C13.8702 17.3973 13.4624 17.75 12.9722 17.75H11.8611C11.3709 17.75 10.9631 17.3973 10.8776 16.9318Z';
                    width = 16;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, busSvgPath1, true) +
                            getPOISVGPath(color, busSvgPath2, true) +
                            getPOISVGPath(color, busSvgPath3, true) +
                            getPOISVGPath(color, busSvgPath4, true) +
                            getPOISVGPath(color, busSvgPath5, true) +
                            getPOISVGPath(color, busSvgPath6, true),
                    );
                    mapIcon = 'transportation2.png';
                    break;
                case 'subway stations':
                    const subwaySvgPath1 =
                        'M11.7501 1.5H5.75013C4.36942 1.5 3.25013 2.61929 3.25013 4V11C3.25013 12.3807 4.36942 13.5 5.75013 13.5H11.7501C13.1308 13.5 14.2501 12.3807 14.2501 11V4C14.2501 2.61929 13.1308 1.5 11.7501 1.5ZM5.75013 0C3.541 0 1.75013 1.79086 1.75013 4V11C1.75013 13.2091 3.541 15 5.75013 15H11.7501C13.9593 15 15.7501 13.2091 15.7501 11V4C15.7501 1.79086 13.9593 0 11.7501 0H5.75013Z';
                    const subwaySvgPath2 =
                        'M4.52016 15.75L1.11635 17.6545C0.754873 17.8568 0.297877 17.7277 0.0956222 17.3662C-0.106633 17.0047 0.0224421 16.5477 0.383919 16.3455L3.93563 14.3582C4.06245 14.2873 4.20535 14.25 4.35068 14.25H13.1496C13.2949 14.25 13.4378 14.2873 13.5646 14.3582L17.1164 16.3455C17.4778 16.5477 17.6069 17.0047 17.4046 17.3662C17.2024 17.7277 16.7454 17.8568 16.3839 17.6545L12.9801 15.75H4.52016Z';
                    const subwaySvgPath3 =
                        'M5.25014 4.5V5.5H12.2501V4.5H5.25014ZM4.75014 3C4.19785 3 3.75014 3.44772 3.75014 4V6C3.75014 6.55228 4.19785 7 4.75014 7H12.7501C13.3024 7 13.7501 6.55228 13.7501 6V4C13.7501 3.44772 13.3024 3 12.7501 3H4.75014Z';
                    const subwaySvgPath4 =
                        'M5.25014 11.5C5.52628 11.5 5.75014 11.2761 5.75014 11C5.75014 10.7239 5.52628 10.5 5.25014 10.5C4.974 10.5 4.75014 10.7239 4.75014 11C4.75014 11.2761 4.974 11.5 5.25014 11.5ZM5.25014 12.5C6.07856 12.5 6.75014 11.8284 6.75014 11C6.75014 10.1716 6.07856 9.5 5.25014 9.5C4.42171 9.5 3.75014 10.1716 3.75014 11C3.75014 11.8284 4.42171 12.5 5.25014 12.5Z';
                    const subwaySvgPath5 =
                        'M12.2501 11.5C12.5263 11.5 12.7501 11.2761 12.7501 11C12.7501 10.7239 12.5263 10.5 12.2501 10.5C11.974 10.5 11.7501 10.7239 11.7501 11C11.7501 11.2761 11.974 11.5 12.2501 11.5ZM12.2501 12.5C13.0786 12.5 13.7501 11.8284 13.7501 11C13.7501 10.1716 13.0786 9.5 12.2501 9.5C11.4217 9.5 10.7501 10.1716 10.7501 11C10.7501 11.8284 11.4217 12.5 12.2501 12.5Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, subwaySvgPath1, true) +
                            getPOISVGPath(color, subwaySvgPath2, true) +
                            getPOISVGPath(color, subwaySvgPath3, true) +
                            getPOISVGPath(color, subwaySvgPath4, true) +
                            getPOISVGPath(color, subwaySvgPath5, true),
                    );
                    mapIcon = 'transportation.png';
                    break;
                case 'grocery stores':
                case 'shopping':
                    const grocerySvgPath1 =
                        'M17.7375 1.5C17.4771 1.5 17.1938 1.61249 16.9211 1.99512C16.6322 2.40053 16.3701 3.09939 16.261 4.19141C16.1087 5.71492 15.7432 8.00995 15.133 9.94238C14.8296 10.9035 14.4509 11.8237 13.9778 12.5186C13.5201 13.1906 12.8501 13.8262 11.9338 13.8262H2.44553C2.03134 13.8262 1.69557 13.4903 1.69553 13.0762C1.69553 12.662 2.03132 12.3262 2.44553 12.3262H11.9338C12.0849 12.3262 12.3442 12.2231 12.6897 11.7393H4.34006C3.87264 11.7392 3.24235 11.6443 2.67893 11.1895C2.11171 10.7313 1.72303 9.99723 1.5549 8.94434L1.55295 8.93359L1.551 8.92188L1.00705 4.70312C0.944248 4.21473 1.30842 3.77518 1.80002 3.74609L14.9387 2.96875C15.1042 2.22442 15.357 1.60557 15.6994 1.125C16.2114 0.40654 16.9237 0 17.7375 0V1.5ZM2.5842 5.20117L3.0383 8.72266C3.16836 9.52176 3.42763 9.86593 3.62131 10.0225C3.81997 10.1829 4.06394 10.2392 4.34006 10.2393H13.4426C13.532 10.0033 13.6194 9.753 13.7024 9.49023C14.216 7.86333 14.5502 5.92264 14.718 4.48438L2.5842 5.20117Z';
                    const grocerySvgPath2 =
                        'M4.73735 15.75C5.01349 15.75 5.23735 15.5261 5.23735 15.25C5.23735 14.9739 5.01349 14.75 4.73735 14.75C4.4612 14.75 4.23735 14.9739 4.23735 15.25C4.23735 15.5261 4.4612 15.75 4.73735 15.75ZM4.73735 17.25C5.84192 17.25 6.73735 16.3546 6.73735 15.25C6.73735 14.1454 5.84192 13.25 4.73735 13.25C3.63278 13.25 2.73735 14.1454 2.73735 15.25C2.73735 16.3546 3.63278 17.25 4.73735 17.25Z';
                    const grocerySvgPath3 =
                        'M10.7373 15.75C11.0135 15.75 11.2373 15.5261 11.2373 15.25C11.2373 14.9739 11.0135 14.75 10.7373 14.75C10.4612 14.75 10.2373 14.9739 10.2373 15.25C10.2373 15.5261 10.4612 15.75 10.7373 15.75ZM10.7373 17.25C11.8419 17.25 12.7373 16.3546 12.7373 15.25C12.7373 14.1454 11.8419 13.25 10.7373 13.25C9.63278 13.25 8.73735 14.1454 8.73735 15.25C8.73735 16.3546 9.63278 17.25 10.7373 17.25Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, grocerySvgPath1) +
                            getPOISVGPath(color, grocerySvgPath2, true) +
                            getPOISVGPath(color, grocerySvgPath3, true),
                    );
                    mapIcon = 'shopping1.png';
                    break;
                case 'shopping malls':
                    const shoppingMallSvgPath1 =
                        'M2.86683 5C2.73983 5 2.633 5.09522 2.61847 5.22139L1.50856 14.857C1.42308 15.5991 2.00332 16.25 2.75035 16.25H12.2083C12.9673 16.25 13.5512 15.579 13.4463 14.8272L12.105 5.21545C12.0878 5.09192 11.9821 5 11.8574 5H2.86683ZM1.12832 5.04974C1.23006 4.16656 1.97781 3.5 2.86683 3.5H11.8574C12.7304 3.5 13.4699 4.14347 13.5906 5.00814L14.9319 14.6199C15.1627 16.2738 13.8782 17.75 12.2083 17.75H2.75035C1.10689 17.75 -0.169652 16.318 0.0184131 14.6853L1.12832 5.04974Z';
                    const shoppingMallSvgPath2 =
                        'M7.33642 1C5.72671 1 4.42178 2.30493 4.42178 3.91463V6.875H3.42178V3.91463C3.42178 1.75264 5.17443 0 7.33642 0C9.49841 0 11.2511 1.75264 11.2511 3.91463V6.875H10.2511V3.91463C10.2511 2.30493 8.94613 1 7.33642 1Z';
                    const shoppingMallSvgPath3 =
                        'M4.60404 6.70833C4.60404 7.09953 4.29829 7.41667 3.92112 7.41667C3.54395 7.41667 3.23819 7.09953 3.23819 6.70833C3.23819 6.31713 3.54395 6 3.92112 6C4.29829 6 4.60404 6.31713 4.60404 6.70833Z';
                    const shoppingMallSvgPath4 =
                        'M11.4331 6.70833C11.4331 7.09953 11.1274 7.41667 10.7502 7.41667C10.373 7.41667 10.0673 7.09953 10.0673 6.70833C10.0673 6.31713 10.373 6 10.7502 6C11.1274 6 11.4331 6.31713 11.4331 6.70833Z';
                    width = 15;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, shoppingMallSvgPath1, true) +
                            getPOISVGPath(color, shoppingMallSvgPath2, true) +
                            getPOISVGPath(color, shoppingMallSvgPath3) +
                            getPOISVGPath(color, shoppingMallSvgPath4),
                    );
                    mapIcon = 'shopping2.png';
                    break;
                case 'department stores':
                    const departmentStoresSvgPath1 =
                        'M1.80999 7.70652V15.75C1.80999 16.3023 2.2577 16.75 2.80999 16.75H10.1715C10.2268 16.75 10.2715 16.7052 10.2715 16.65V12.25C10.2715 11.9738 10.4954 11.75 10.7715 11.75H12.477C12.7531 11.75 12.977 11.9738 12.977 12.25V16.65C12.977 16.7052 13.0217 16.75 13.077 16.75H14.1433C14.6956 16.75 15.1433 16.3023 15.1433 15.75V7.70652M4.97665 13.75H6.97665C7.2528 13.75 7.47665 13.5261 7.47665 13.25V11.25C7.47665 10.9739 7.2528 10.75 6.97665 10.75H4.97665C4.70051 10.75 4.47665 10.9739 4.47665 11.25V13.25C4.47665 13.5261 4.70051 13.75 4.97665 13.75ZM2.45177 2.83696H14.6127C15.0832 2.83696 15.49 3.16491 15.5899 3.62467L16.2133 6.49423C16.3487 7.1175 15.8739 7.70652 15.2361 7.70652H1.75047C1.10208 7.70652 0.625133 7.09897 0.779064 6.46912L1.48036 3.59955C1.58977 3.15189 1.99093 2.83696 2.45177 2.83696ZM2.85346 2.83696H14.0998C14.6761 2.83696 15.1433 2.36978 15.1433 1.79348C15.1433 1.21718 14.6761 0.75 14.0998 0.75H2.85346C2.27717 0.75 1.80999 1.21718 1.80999 1.79348C1.80999 2.36978 2.27717 2.83696 2.85346 2.83696Z';
                    width = 17;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, departmentStoresSvgPath1, false, true, 1.5),
                    );
                    mapIcon = 'shop.png';
                    break;
                case 'restaurants':
                    const restaurantSvgPath1 =
                        'M1.29707 2.33447C0.206732 4.4808 0.906087 6.43184 2.02067 7.58697C2.51663 8.10098 2.92287 8.74038 2.92287 9.45464V15.546C2.92287 16.0153 3.30327 16.3957 3.77251 16.3957C4.24175 16.3957 4.62215 16.0153 4.62215 15.546V9.47633C4.62215 8.75048 5.04473 8.10458 5.54329 7.57705C6.60169 6.45718 7.19035 4.59671 6.35471 2.53648C5.47709 0.372765 2.35458 0.252745 1.29707 2.33447Z';
                    const restaurantSvgPath2 =
                        'M9.3966 8.16917C8.33478 6.80797 8.72497 3.98837 9.54461 0.85905C9.57208 0.7542 9.72223 0.762693 9.73795 0.869934L10.4491 5.72071C10.4652 5.83023 10.6209 5.83638 10.6456 5.72847L11.7449 0.913837C11.7695 0.806025 11.925 0.812017 11.9413 0.921403L12.6541 5.72004C12.6704 5.82956 12.8262 5.83537 12.8506 5.72737L13.9566 0.827835C13.9801 0.72386 14.1273 0.7241 14.1498 0.828287C14.8684 4.15314 15.0643 6.84913 14.0555 8.158C13.4505 8.94305 12.5898 9.71494 12.5898 10.7061V15.5193C12.5898 16.0033 12.1974 16.3957 11.7134 16.3957C11.2293 16.3957 10.837 16.0033 10.837 15.5193L10.837 10.6748C10.837 9.69733 9.9978 8.93986 9.3966 8.16917Z';
                    width = 16;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, restaurantSvgPath1, false, true, 1.5) +
                            getPOISVGPath(color, restaurantSvgPath2, false, true, 1.5),
                    );
                    mapIcon = 'restaurant.png';
                    break;
                case 'coffee shops':
                    const coffeeShopSvgPath1 =
                        'M13.6198 14.5276C13.9081 14.5279 14.3004 14.7923 14.1941 15.2415C14.107 15.6088 13.8184 15.8736 13.5036 16.0609C13.1768 16.2551 12.7376 16.4177 12.198 16.5501C11.1152 16.8157 9.53232 16.9817 7.38938 16.9817C5.23107 16.9817 3.58016 16.8149 2.43137 16.5511C1.85906 16.4196 1.38933 16.2596 1.03879 16.0706C0.710084 15.8933 0.382128 15.6348 0.280005 15.2562C0.224198 15.0488 0.290811 14.8504 0.412818 14.7181C0.527934 14.5933 0.688198 14.5278 0.849341 14.5276H13.6198ZM2.655 15.5765C3.70367 15.8173 5.27278 15.9817 7.38938 15.9817C9.49216 15.9817 10.986 15.8173 11.9597 15.5784C12.0247 15.5625 12.0866 15.544 12.1462 15.5276H2.46262C2.52447 15.5434 2.5883 15.5612 2.655 15.5765Z';
                    const coffeeShopSvgPath2 =
                        'M5.86529 0.022031C6.01868 -0.0247229 6.20692 0.000145048 6.34868 0.123594L6.4063 0.183164L6.51763 0.324765C7.04338 1.03745 7.0997 1.79866 6.92486 2.44684C6.74545 3.11176 6.32439 3.66222 5.93169 3.96051C5.14983 4.55407 4.89245 5.02125 4.8272 5.31305C4.76609 5.58661 4.85859 5.76691 4.95122 5.8648C5.07525 5.99585 5.10134 6.15647 5.08697 6.27594C5.07368 6.38627 5.02785 6.4735 4.98052 6.53375C4.93355 6.59352 4.8575 6.66157 4.7481 6.70074C4.62708 6.74398 4.45824 6.7501 4.30279 6.65094C3.4703 6.11989 3.08328 5.31918 3.13677 4.48199C3.18895 3.66674 3.65276 2.88245 4.38189 2.31305C5.29093 1.60322 5.49644 0.765586 5.50396 0.495664C5.51074 0.24768 5.68464 0.0771508 5.86529 0.022031ZM10.1885 0.022031C10.3419 -0.0247235 10.5302 0.000141062 10.6719 0.123594L10.7295 0.183164L10.8409 0.324765C11.3666 1.03745 11.4229 1.79866 11.2481 2.44684C11.0686 3.112 10.6468 3.6623 10.254 3.96051C9.47224 4.554 9.21569 5.02127 9.15044 5.31305C9.08933 5.58661 9.18184 5.76691 9.27447 5.8648C9.39849 5.99586 9.42458 6.15647 9.41021 6.27594C9.39692 6.38627 9.35109 6.4735 9.30376 6.53375C9.25679 6.59352 9.18075 6.66157 9.07134 6.70074C8.95033 6.74398 8.78149 6.75011 8.62603 6.65094C7.79353 6.11989 7.40652 5.31918 7.46001 4.48199C7.51219 3.66674 7.976 2.88245 8.70513 2.31305C9.61417 1.60322 9.81969 0.765585 9.8272 0.495664C9.83398 0.247676 10.0079 0.077148 10.1885 0.022031ZM5.99615 2.00152C5.76524 2.3707 5.44263 2.75326 4.99712 3.10113C4.51255 3.47959 4.23606 3.94261 4.1563 4.37359C4.40172 3.98052 4.78406 3.57625 5.32622 3.16461C5.55224 2.99302 5.84024 2.62639 5.95904 2.18609C5.97528 2.12585 5.98682 2.06414 5.99615 2.00152ZM10.3194 2.00152C10.0885 2.3707 9.76587 2.75326 9.32036 3.10113C8.83579 3.47959 8.5593 3.94261 8.47954 4.37359C8.72497 3.98052 9.1073 3.57625 9.64947 3.16461C9.87549 2.99302 10.1635 2.62639 10.2823 2.18609C10.2985 2.12585 10.3101 2.06414 10.3194 2.00152Z';
                    const coffeeShopSvgPath3 =
                        'M13.6192 5.55047C14.0965 5.55047 14.4716 5.9409 14.4688 6.40594C14.4683 6.48482 14.4664 6.56331 14.4649 6.64129H15.5205C16.0908 6.64129 16.6604 6.88945 17.044 7.33172C17.4469 7.79652 17.6187 8.44827 17.4102 9.15008C17.2107 9.82131 16.6882 10.4677 15.8594 11.0671C15.082 11.6292 13.9867 12.1837 12.4971 12.7097C11.9979 13.256 11.4071 13.6846 10.7256 13.9782C9.97901 14.2999 9.1825 14.3229 8.53517 14.3229H6.04005C5.42369 14.3229 4.6907 14.2978 3.98634 14.0368C1.35892 13.0634 0.0227462 10.3873 1.39369e-05 6.40594C-0.00262814 5.94277 0.370701 5.55053 0.849623 5.55047H13.6192ZM1.51662 7.05047C1.67019 10.3279 2.8451 12.0145 4.50783 12.6306C4.94232 12.7914 5.44201 12.8229 6.04005 12.8229H8.53517C9.17659 12.8229 9.69487 12.7885 10.1319 12.6003C11.6566 11.9433 12.7936 10.1608 12.9502 7.05047H1.51662ZM14.3604 8.14129C14.2503 9.02519 14.056 9.83343 13.7822 10.5554C14.2722 10.3131 14.667 10.0781 14.9795 9.85223C15.6589 9.36093 15.9019 8.96109 15.9727 8.72332C16.0342 8.51615 15.981 8.39474 15.9111 8.31415C15.8219 8.21126 15.6706 8.14129 15.5205 8.14129H14.3604Z';
                    height = 17;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, coffeeShopSvgPath1) +
                            getPOISVGPath(color, coffeeShopSvgPath2) +
                            getPOISVGPath(color, coffeeShopSvgPath3),
                    );
                    mapIcon = 'coffee.png';
                    break;
                case 'schools':
                case 'elementary schools':
                case 'schools/universities':
                    const schoolSvgPath1 =
                        'M1.5 10.5V16.5H2.5V10.5H1.5ZM1 9C0.447715 9 0 9.44772 0 10V17C0 17.5523 0.447715 18 1 18H3C3.55228 18 4 17.5523 4 17V10C4 9.44772 3.55228 9 3 9H1Z';
                    const schoolSvgPath2 =
                        'M13.5 10.5V16.5H14.5V10.5H13.5ZM13 9C12.4477 9 12 9.44772 12 10V17C12 17.5523 12.4477 18 13 18H15C15.5523 18 16 17.5523 16 17V10C16 9.44772 15.5523 9 15 9H13Z';
                    const schoolSvgPath3 =
                        'M8.0824 4.82217C7.99138 4.75192 7.86417 4.75282 7.77414 4.82434L2.99291 8.62294C2.66859 8.88061 2.1968 8.82657 1.93914 8.50226C1.68147 8.17794 1.73551 7.70615 2.05982 7.44848L6.84106 3.64988C7.47125 3.14921 8.36169 3.14294 8.99887 3.6347L13.932 7.44198C14.2599 7.69505 14.3205 8.16604 14.0675 8.49395C13.8144 8.82186 13.3434 8.88253 13.0155 8.62945L8.0824 4.82217Z';
                    const schoolSvgPath4 =
                        'M7.48684 14.8929V16.3571C7.48684 17.3236 6.70334 18.1071 5.73684 18.1071H3.36842C2.95421 18.1071 2.61842 17.7714 2.61842 17.3571C2.61842 16.9429 2.95421 16.6071 3.36842 16.6071H5.73684C5.87491 16.6071 5.98684 16.4952 5.98684 16.3571V14.6429C5.98684 13.9525 6.54649 13.3929 7.23684 13.3929H8.77611C9.46647 13.3929 10.0261 13.9525 10.0261 14.6429V16.3571C10.0261 16.4952 10.138 16.6071 10.2761 16.6071H13.4737C13.8879 16.6071 14.2237 16.9429 14.2237 17.3571C14.2237 17.7714 13.8879 18.1071 13.4737 18.1071H10.2761C9.30962 18.1071 8.52611 17.3236 8.52611 16.3571V14.8929H7.48684Z';
                    const schoolSvgPath5 =
                        'M8.0001 11C8.77454 11 9.44747 10.3536 9.44747 9.5C9.44747 8.64643 8.77454 8 8.0001 8C7.22566 8 6.55273 8.64643 6.55273 9.5C6.55273 10.3536 7.22566 11 8.0001 11ZM8.0001 12.5C9.62789 12.5 10.9475 11.1569 10.9475 9.5C10.9475 7.84315 9.62789 6.5 8.0001 6.5C6.37232 6.5 5.05273 7.84315 5.05273 9.5C5.05273 11.1569 6.37232 12.5 8.0001 12.5Z';
                    const schoolSvgPath6 =
                        'M7.5 0.6C7.5 0.268629 7.76863 0 8.1 0H10.0053C10.3366 0 10.6053 0.26863 10.6053 0.6V2.11429C10.6053 2.44566 10.3366 2.71429 10.0053 2.71429H8.5V3.92857C8.5 4.20471 8.27614 4.42857 8 4.42857C7.72386 4.42857 7.5 4.20471 7.5 3.92857V0.6ZM8.5 1.71429H9.60526V1H8.5V1.71429Z';
                    const schoolSvgPath7 = '';
                    width = 16;
                    height = 19;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, schoolSvgPath1, true) +
                            getPOISVGPath(color, schoolSvgPath2, true) +
                            getPOISVGPath(color, schoolSvgPath3, true) +
                            getPOISVGPath(color, schoolSvgPath4, true) +
                            getPOISVGPath(color, schoolSvgPath5, true) +
                            getPOISVGPath(color, schoolSvgPath6, true) +
                            getPOISVGPath(color, schoolSvgPath7, true),
                    );
                    mapIcon = 'school1.png';
                    break;
                case 'middle schools':
                case 'high schools':
                case 'colleges':
                    const collegeSvgPath1 =
                        'M7.80691 0.6C7.80691 0.268629 8.07554 0 8.40691 0H10.366C10.6974 0 10.966 0.268629 10.966 0.6V2.1C10.966 2.43137 10.6974 2.7 10.366 2.7H8.80691V3.4048C8.80691 3.68095 8.58305 3.9048 8.30691 3.9048C8.03076 3.9048 7.80691 3.68095 7.80691 3.4048V0.6ZM8.80691 1.7H9.966V1H8.80691V1.7Z';
                    const collegeSvgPath2 =
                        'M8.37018 4.3134C8.29582 4.27462 8.20696 4.27572 8.13358 4.31633L2.77473 7.28125C2.70189 7.32155 2.67352 7.36553 2.65957 7.40131C2.64295 7.44396 2.63784 7.50109 2.65369 7.5625C2.66955 7.62391 2.70168 7.67142 2.73687 7.70069C2.7664 7.72525 2.81252 7.75 2.89576 7.75H13.9416C14.0265 7.75 14.0727 7.72461 14.1019 7.70001C14.1369 7.67042 14.169 7.62209 14.1844 7.5595C14.1997 7.4969 14.1936 7.43921 14.1762 7.39676C14.1617 7.36147 14.1325 7.31761 14.0571 7.27832L8.37018 4.3134ZM7.4074 3.00382C7.92109 2.71961 8.54306 2.71191 9.06363 2.98331L14.7506 5.94823C16.3738 6.79453 15.7722 9.25 13.9416 9.25H2.89576C1.08836 9.25 0.46707 6.84374 2.04855 5.96875L7.4074 3.00382Z';
                    const collegeSvgPath3 =
                        'M3.02273 8.25C3.43694 8.25 3.77273 8.58579 3.77273 9V15C3.77273 15.4142 3.43694 15.75 3.02273 15.75C2.60851 15.75 2.27273 15.4142 2.27273 15V9C2.27273 8.58579 2.60851 8.25 3.02273 8.25ZM5.77273 8.25C6.18694 8.25 6.52273 8.58579 6.52273 9V15C6.52273 15.4142 6.18694 15.75 5.77273 15.75C5.35851 15.75 5.02273 15.4142 5.02273 15V9C5.02273 8.58579 5.35851 8.25 5.77273 8.25ZM8.52273 8.25C8.93694 8.25 9.27273 8.58579 9.27273 9V15C9.27273 15.4142 8.93694 15.75 8.52273 15.75C8.10851 15.75 7.77273 15.4142 7.77273 15V9C7.77273 8.58579 8.10851 8.25 8.52273 8.25ZM11.2727 8.25C11.6869 8.25 12.0227 8.58579 12.0227 9V15C12.0227 15.4142 11.6869 15.75 11.2727 15.75C10.8585 15.75 10.5227 15.4142 10.5227 15V9C10.5227 8.58579 10.8585 8.25 11.2727 8.25ZM14.0227 8.25C14.4369 8.25 14.7727 8.58579 14.7727 9V15C14.7727 15.4142 14.4369 15.75 14.0227 15.75C13.6085 15.75 13.2727 15.4142 13.2727 15V9C13.2727 8.58579 13.6085 8.25 14.0227 8.25Z';
                    const collegeSvgPath4 =
                        'M1.11364 15.5125C1.11364 15.2364 1.33749 15.0125 1.61364 15.0125H15.4318C15.708 15.0125 15.9318 15.2364 15.9318 15.5125C15.9318 15.7886 15.708 16.0125 15.4318 16.0125H1.61364C1.33749 16.0125 1.11364 15.7886 1.11364 15.5125Z';
                    const collegeSvgPath5 =
                        'M0 17C0 16.5858 0.335786 16.25 0.75 16.25H16.2955C16.7097 16.25 17.0455 16.5858 17.0455 17C17.0455 17.4142 16.7097 17.75 16.2955 17.75H0.75C0.335786 17.75 0 17.4142 0 17Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, collegeSvgPath1, true) +
                            getPOISVGPath(color, collegeSvgPath2, true) +
                            getPOISVGPath(color, collegeSvgPath3, true) +
                            getPOISVGPath(color, collegeSvgPath4, true) +
                            getPOISVGPath(color, collegeSvgPath5, true),
                    );
                    mapIcon = 'school2.png';
                    break;
                case 'universities':
                    const universitiesSvgPath1 =
                        'M8.77198 1.5291C8.69876 1.4903 8.61107 1.4903 8.53785 1.5291L1.63294 5.18844C1.45774 5.28128 1.45518 5.53137 1.62844 5.62779L8.53335 9.47009C8.60893 9.51215 8.70089 9.51215 8.77647 9.47009L15.6814 5.62779C15.8546 5.53137 15.8521 5.28128 15.6769 5.18844L8.77198 1.5291ZM7.83545 0.203722C8.34799 -0.0679079 8.96183 -0.067907 9.47438 0.203723L16.3793 3.86305C17.6057 4.51299 17.6236 6.26363 16.4108 6.93852L9.50584 10.7808C8.97676 11.0752 8.33307 11.0752 7.80398 10.7808L0.899071 6.93852C-0.313766 6.26363 -0.295853 4.51299 0.930536 3.86305L7.83545 0.203722Z';
                    const universitiesSvgPath2 =
                        'M4.19438 10.7553L4.19437 12.3502C4.19437 12.7976 4.4334 13.2108 4.82116 13.4338L7.67306 15.0741C8.39102 15.487 9.2778 15.4721 9.98149 15.0353L12.5247 13.4567C12.892 13.2286 13.1154 12.827 13.1154 12.3946L13.1154 10.8022L10.1853 12.4835C9.36513 12.9541 8.36068 12.9703 7.52573 12.5264L4.19438 10.7553ZM2.69438 9.67355C2.69439 9.03236 3.37725 8.62204 3.9434 8.92304L8.22988 11.202C8.6094 11.4037 9.06597 11.3964 9.43878 11.1825L13.3424 8.94256C13.9091 8.61741 14.6154 9.0265 14.6154 9.67982L14.6154 12.3946C14.6154 13.3458 14.1239 14.2294 13.3158 14.7311L10.7726 16.3098C9.59977 17.0378 8.1218 17.0626 6.9252 16.3744L4.0733 14.7341C3.22023 14.2434 2.69437 13.3343 2.69437 12.3502L2.69438 9.67355Z';
                    const universitiesSvgPath3 =
                        'M15.7549 11.2848V5.06259H17.2549V11.2848C17.2549 11.699 16.9191 12.0348 16.5049 12.0348C16.0907 12.0348 15.7549 11.699 15.7549 11.2848Z';
                    height = 17;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, universitiesSvgPath1, true) +
                            getPOISVGPath(color, universitiesSvgPath2, true) +
                            getPOISVGPath(color, universitiesSvgPath3, true),
                    );
                    mapIcon = 'university.png';
                    break;
                case 'hospitals':
                    const hospitalsSvgPath1 =
                        'M1.01528 7.02856L6.51528 1.07163C6.91123 0.64279 7.58877 0.642788 7.98472 1.07163L13.4847 7.02856C13.6553 7.21329 13.75 7.45549 13.75 7.70692V15.2759C13.75 15.8282 13.3023 16.2759 12.75 16.2759H1.75C1.19772 16.2759 0.75 15.8282 0.75 15.2759V7.70692C0.75 7.45549 0.844714 7.21329 1.01528 7.02856Z';
                    const hospitalsSvgPath2 =
                        'M4.39544 8.64513H6.01362C6.06885 8.64513 6.11362 8.60036 6.11362 8.54513V6.7759C6.11362 6.72067 6.15839 6.6759 6.21362 6.6759H8.28635C8.34158 6.6759 8.38635 6.72067 8.38635 6.7759V8.54513C8.38635 8.60036 8.43112 8.64513 8.48635 8.64513H10.1045C10.1598 8.64513 10.2045 8.6899 10.2045 8.74513V11.0067C10.2045 11.0619 10.1598 11.1067 10.1045 11.1067H8.48635C8.43112 11.1067 8.38635 11.1514 8.38635 11.2067V12.9759C8.38635 13.0311 8.34158 13.0759 8.28635 13.0759H6.21362C6.15839 13.0759 6.11362 13.0311 6.11362 12.9759V11.2067C6.11362 11.1514 6.06885 11.1067 6.01362 11.1067H4.39544C4.34021 11.1067 4.29544 11.0619 4.29544 11.0067V8.74513C4.29544 8.6899 4.34021 8.64513 4.39544 8.64513Z';
                    width = 15;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, hospitalsSvgPath1, false, true, 1.5) +
                            getPOISVGPath(color, hospitalsSvgPath2, false, true, 1.5),
                    );
                    mapIcon = 'health.png';
                    break;
                case 'movie theaters':
                    const movieSvgPath1 =
                        'M16 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V16C1.5 16.2761 1.72386 16.5 2 16.5H16C16.2761 16.5 16.5 16.2761 16.5 16V2C16.5 1.72386 16.2761 1.5 16 1.5ZM2 0C0.895431 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895431 17.1046 0 16 0H2Z';
                    const movieSvgPath2 =
                        'M7.50001 6.47585V11.5242L10.7721 9.00004L7.50001 6.47585ZM6.00001 5.96725C6.00001 4.92936 7.19173 4.34357 8.01351 4.97752L11.9449 8.01032C12.5936 8.51071 12.5936 9.48938 11.9449 9.98977L8.01351 13.0226C7.19173 13.6565 6.00001 13.0707 6.00001 12.0328V5.96725Z';
                    const movieSvgPath3 =
                        'M2.89474 4.17651V5.55151H3.73685V4.17651H2.89474ZM2.39474 3.17651C2.1186 3.17651 1.89474 3.40037 1.89474 3.67651V6.05151C1.89474 6.32766 2.1186 6.55151 2.39475 6.55151H4.23685C4.51299 6.55151 4.73685 6.32766 4.73685 6.05151V3.67651C4.73685 3.40037 4.51299 3.17651 4.23685 3.17651H2.39474Z';
                    const movieSvgPath4 =
                        'M2.89474 8.41181V9.78681H3.73685V8.41181H2.89474ZM2.39474 7.41181C2.1186 7.41181 1.89474 7.63567 1.89474 7.91181V10.2868C1.89474 10.563 2.1186 10.7868 2.39475 10.7868H4.23685C4.51299 10.7868 4.73685 10.563 4.73685 10.2868V7.91181C4.73685 7.63567 4.51299 7.41181 4.23685 7.41181H2.39474Z';
                    const movieSvgPath5 =
                        'M2.89474 12.6471V14.0221H3.73685V12.6471H2.89474ZM2.39474 11.6471C2.1186 11.6471 1.89474 11.871 1.89474 12.1471V14.5221C1.89474 14.7982 2.1186 15.0221 2.39475 15.0221H4.23685C4.51299 15.0221 4.73685 14.7982 4.73685 14.5221V12.1471C4.73685 11.871 4.51299 11.6471 4.23685 11.6471H2.39474Z';
                    const movieSvgPath6 =
                        'M14.2632 4.17651V5.55151H15.1053V4.17651H14.2632ZM13.7632 3.17651C13.487 3.17651 13.2632 3.40037 13.2632 3.67651V6.05151C13.2632 6.32766 13.487 6.55151 13.7632 6.55151H15.6053C15.8814 6.55151 16.1053 6.32766 16.1053 6.05151V3.67651C16.1053 3.40037 15.8814 3.17651 15.6053 3.17651H13.7632Z';
                    const movieSvgPath7 =
                        'M14.2632 8.41181V9.78681H15.1053V8.41181H14.2632ZM13.7632 7.41181C13.487 7.41181 13.2632 7.63567 13.2632 7.91181V10.2868C13.2632 10.563 13.487 10.7868 13.7632 10.7868H15.6053C15.8814 10.7868 16.1053 10.563 16.1053 10.2868V7.91181C16.1053 7.63567 15.8814 7.41181 15.6053 7.41181H13.7632Z';
                    const movieSvgPath8 =
                        'M14.2632 12.6471V14.0221H15.1053V12.6471H14.2632ZM13.7632 11.6471C13.487 11.6471 13.2632 11.871 13.2632 12.1471V14.5221C13.2632 14.7982 13.487 15.0221 13.7632 15.0221H15.6053C15.8814 15.0221 16.1053 14.7982 16.1053 14.5221V12.1471C16.1053 11.871 15.8814 11.6471 15.6053 11.6471H13.7632Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, movieSvgPath1, true) +
                            getPOISVGPath(color, movieSvgPath2, true) +
                            getPOISVGPath(color, movieSvgPath3, true) +
                            getPOISVGPath(color, movieSvgPath4, true) +
                            getPOISVGPath(color, movieSvgPath5, true) +
                            getPOISVGPath(color, movieSvgPath6, true) +
                            getPOISVGPath(color, movieSvgPath7, true) +
                            getPOISVGPath(color, movieSvgPath8, true),
                    );
                    mapIcon = 'movie.png';
                    break;
                case 'arenas':
                    const arenasSvgPath1 =
                        'M8.49036 5.86366C6.57725 5.86662 4.77747 6.65363 3.74818 8.14162C3.73885 8.1551 3.72233 8.19203 3.72965 8.25567L4.69636 16.6644C4.74367 17.0759 4.44843 17.4478 4.03693 17.4951C3.62542 17.5424 3.25348 17.2472 3.20617 16.8357L2.23946 8.42699C2.19621 8.05074 2.27199 7.63895 2.51456 7.28828C3.87998 5.31438 6.19169 4.36721 8.48805 4.36367C10.7861 4.36012 13.1685 5.29848 14.7244 7.22404C15.0208 7.59091 15.1238 8.04792 15.0753 8.47007L14.1135 16.8357C14.0662 17.2472 13.6943 17.5424 13.2827 17.4951C12.8712 17.4478 12.576 17.0759 12.6233 16.6644L13.5851 8.29875C13.5931 8.2287 13.5726 8.18529 13.5577 8.16678C12.3269 6.64353 10.4018 5.86071 8.49036 5.86366Z';
                    const arenasSvgPath2 =
                        'M0.671742 16.75C0.671742 16.3358 1.00753 16 1.42174 16H15.8979C16.3121 16 16.6479 16.3358 16.6479 16.75C16.6479 17.1643 16.3121 17.5 15.8979 17.5H1.42174C1.00753 17.5 0.671742 17.1643 0.671742 16.75Z';
                    const arenasSvgPath3 =
                        'M15.7431 11.3918C9.81731 6.77484 4.09211 9.24451 1.55343 11.3759C1.52064 11.4035 1.48569 11.4661 1.50509 11.5615L2.52955 16.6006C2.61208 17.0065 2.34992 17.4025 1.94401 17.485C1.5381 17.5675 1.14215 17.3054 1.05962 16.8995L0.0351563 11.8603C-0.0826787 11.2807 0.094162 10.6425 0.588926 10.2271C3.44813 7.82661 9.98094 5.00077 16.665 10.2086C17.1787 10.6089 17.4057 11.2593 17.2927 11.8765L16.3763 16.885C16.3018 17.2925 15.911 17.5623 15.5036 17.4878C15.0961 17.4132 14.8263 17.0225 14.9008 16.6151L15.8172 11.6065C15.8339 11.5154 15.7973 11.4341 15.7431 11.3918Z';
                    const arenasSvgPath4 =
                        'M2.08626 2.43064C2.49697 2.37685 2.87351 2.6662 2.9273 3.0769L3.6892 8.89509C3.74299 9.30579 3.45364 9.68234 3.04293 9.73612C2.63223 9.7899 2.25568 9.50056 2.2019 9.08985L1.44 3.27167C1.38621 2.86096 1.67556 2.48442 2.08626 2.43064Z';
                    const arenasSvgPath5 =
                        'M15.2334 2.43064C15.6441 2.48442 15.9335 2.86096 15.8797 3.27167L15.1178 9.08985C15.064 9.50056 14.6874 9.7899 14.2767 9.73612C13.866 9.68234 13.5767 9.30579 13.6305 8.89509L14.3924 3.0769C14.4462 2.6662 14.8227 2.37685 15.2334 2.43064Z';
                    const arenasSvgPath6 =
                        'M7.75507 11.6819C7.617 11.6819 7.50508 11.7938 7.50508 11.9319V15.7803C7.50508 16.1946 7.16929 16.5303 6.75508 16.5303C6.34086 16.5303 6.00508 16.1946 6.00508 15.7803V11.9319C6.00508 10.9654 6.78858 10.1819 7.75507 10.1819H9.5646C10.5311 10.1819 11.3146 10.9654 11.3146 11.9319V15.7803C11.3146 16.1946 10.9788 16.5303 10.5646 16.5303C10.1504 16.5303 9.8146 16.1946 9.8146 15.7803V11.9319C9.8146 11.7938 9.70267 11.6819 9.5646 11.6819H7.75507Z';
                    const arenasSvgPath7 =
                        'M5.54699 0.00288687C5.95963 -0.0331376 6.32335 0.272173 6.35938 0.684817L6.74033 5.04845C6.77635 5.4611 6.47104 5.82481 6.0584 5.86084C5.64575 5.89686 5.28204 5.59155 5.24601 5.17891L4.86506 0.815273C4.82904 0.402629 5.13435 0.0389114 5.54699 0.00288687Z';
                    const arenasSvgPath8 =
                        'M11.5822 0.00288687C11.9949 0.0389114 12.3002 0.402629 12.2641 0.815273L11.8832 5.17891C11.8472 5.59155 11.4834 5.89686 11.0708 5.86084C10.6582 5.82481 10.3528 5.4611 10.3889 5.04845L10.7698 0.684817C10.8058 0.272173 11.1696 -0.0331376 11.5822 0.00288687Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, arenasSvgPath1, true) +
                            getPOISVGPath(color, arenasSvgPath2, true) +
                            getPOISVGPath(color, arenasSvgPath3, true) +
                            getPOISVGPath(color, arenasSvgPath4, true) +
                            getPOISVGPath(color, arenasSvgPath5, true) +
                            getPOISVGPath(color, arenasSvgPath6, true) +
                            getPOISVGPath(color, arenasSvgPath7, true) +
                            getPOISVGPath(color, arenasSvgPath8, true),
                    );
                    mapIcon = 'entertainment3.png';
                    break;
                case 'stadiums':
                    const stadiumsSvgPath1 =
                        'M3.89103 5.49999C1.72231 8.46375 1.11988 12.5259 1.71742 15.6041C1.72735 15.6552 1.78217 15.725 1.87866 15.7402C8.29854 16.755 12.0136 14.6662 14.0015 11.7641C16.0374 8.79195 16.3613 4.82472 15.6717 1.98333C15.6604 1.937 15.6108 1.87594 15.5258 1.8585C9.69796 0.662248 6.01312 2.59996 3.89103 5.49999ZM2.68051 4.61419C5.17571 1.20427 9.47024 -0.915769 15.8275 0.389132C16.4425 0.515369 16.9721 0.981444 17.1294 1.62953C17.8993 4.80174 17.5597 9.22389 15.2391 12.6117C12.8705 16.0695 8.53634 18.3112 1.64446 17.2219C0.970422 17.1153 0.383636 16.6045 0.244909 15.8899C-0.420827 12.4604 0.231944 7.96038 2.68051 4.61419Z';
                    const stadiumsSvgPath2 =
                        'M0.663923 10.4415C0.956816 10.1486 1.43169 10.1486 1.72458 10.4415L7.05792 15.7748C7.35081 16.0677 7.35081 16.5426 7.05792 16.8355C6.76502 17.1284 6.29015 17.1284 5.99726 16.8355L0.663923 11.5022C0.37103 11.2093 0.37103 10.7344 0.663923 10.4415Z';
                    const stadiumsSvgPath3 =
                        'M10.4417 0.663727C10.7346 0.370834 11.2095 0.370834 11.5024 0.663727L16.8357 5.99706C17.1286 6.28995 17.1286 6.76483 16.8357 7.05772C16.5428 7.35061 16.0679 7.35061 15.775 7.05772L10.4417 1.72439C10.1488 1.43149 10.1488 0.95662 10.4417 0.663727Z';
                    const stadiumsSvgPath4 =
                        'M12.2145 5.28495C12.4097 5.48021 12.4097 5.79679 12.2145 5.99205L5.99225 12.2143C5.79699 12.4095 5.48041 12.4095 5.28514 12.2143C5.08988 12.019 5.08988 11.7024 5.28514 11.5072L11.5074 5.28495C11.7026 5.08969 12.0192 5.08969 12.2145 5.28495Z';
                    const stadiumsSvgPath5 =
                        'M9.4317 5.71986C9.63223 5.53001 9.94869 5.53866 10.1385 5.73919L11.7796 7.47253C11.9694 7.67306 11.9608 7.98952 11.7602 8.17937C11.5597 8.36922 11.2432 8.36056 11.0534 8.16003L9.41236 6.4267C9.22251 6.22617 9.23117 5.90971 9.4317 5.71986ZM7.79194 7.58533C7.99312 7.39618 8.30956 7.40594 8.49871 7.60713L10.003 9.20713C10.1921 9.40831 10.1824 9.72474 9.98119 9.9139C9.78 10.103 9.46357 10.0933 9.27442 9.8921L7.77014 8.2921C7.58099 8.09091 7.59075 7.77448 7.79194 7.58533ZM5.72514 9.3339C5.91792 9.13618 6.23447 9.13217 6.43219 9.32495L8.20997 11.0583C8.40769 11.2511 8.41169 11.5676 8.21892 11.7653C8.02614 11.963 7.70959 11.9671 7.51187 11.7743L5.73409 10.0409C5.53637 9.84817 5.53237 9.53161 5.72514 9.3339Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, stadiumsSvgPath1, true) +
                            getPOISVGPath(color, stadiumsSvgPath2, true) +
                            getPOISVGPath(color, stadiumsSvgPath3, true) +
                            getPOISVGPath(color, stadiumsSvgPath4, true) +
                            getPOISVGPath(color, stadiumsSvgPath5, true),
                    );
                    mapIcon = 'sports3.png';
                    break;
                case 'museums':
                    const museumSvgPath1 =
                        'M17.4156 1.34387L14.5735 4.34387L13.8476 3.65613L16.6897 0.656128L17.4156 1.34387Z';
                    const museumSvgPath2 =
                        'M4.15245 14.3439L1.31034 17.3439L0.584392 16.6561L3.4265 13.6561L4.15245 14.3439Z';
                    const museumSvgPath3 =
                        'M16.6897 17.3439L13.8476 14.3439L14.5735 13.6561L17.4156 16.6561L16.6897 17.3439Z';
                    const museumSvgPath4 = 'M13.6579 4.5H4.3421V13.5H13.6579V4.5ZM2.84211 3V15H15.1579V3H2.84211Z';
                    const museumSvgPath5 =
                        'M1.5 1.5V16.5H16.5V1.5H1.5ZM0.5 0C0.223858 0 0 0.223858 0 0.5V17.5C0 17.7761 0.223858 18 0.5 18H17.5C17.7761 18 18 17.7761 18 17.5V0.5C18 0.223858 17.7761 0 17.5 0H0.5Z';
                    const museumSvgPath6 =
                        'M3.4265 4.34387L0.584392 1.34387L1.31034 0.656128L4.15245 3.65613L3.4265 4.34387Z';
                    const museumSvgPath7 =
                        'M6.89797 5.90234C7.11878 5.5515 7.63212 5.52993 7.88137 5.86133L7.9302 5.9375L9.60891 9.00391L10.3042 7.74023L10.3501 7.66797C10.5837 7.35431 11.059 7.34832 11.3003 7.65625L11.3482 7.72656L13.607 11.5977C13.8404 11.9975 13.5523 12.4997 13.0894 12.5H4.89016C4.4565 12.4998 4.16668 12.0538 4.34231 11.6572L6.85501 5.98242L6.89797 5.90234ZM5.5054 11.5H12.3921L10.8394 8.83984L10.1353 10.124C9.90725 10.5391 9.31009 10.5394 9.08255 10.124L7.44192 7.12793L5.5054 11.5Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, museumSvgPath1, true) +
                            getPOISVGPath(color, museumSvgPath2, true) +
                            getPOISVGPath(color, museumSvgPath3, true) +
                            getPOISVGPath(color, museumSvgPath4, true) +
                            getPOISVGPath(color, museumSvgPath5, true) +
                            getPOISVGPath(color, museumSvgPath6, true) +
                            getPOISVGPath(color, museumSvgPath7),
                    );
                    mapIcon = 'museum.png';
                    break;
                case 'entertainment':
                    const entertainmentSvgPath1 =
                        'M5.56371 11.0532C4.32987 9.60442 2.76693 10.6892 3.05874 12.1965C3.07567 12.284 3.19338 12.2983 3.24601 12.2265C3.73644 11.5573 4.75009 11.2065 5.47304 11.2229C5.56213 11.225 5.6215 11.121 5.56371 11.0532Z';
                    const entertainmentSvgPath2 =
                        'M7.08411 10.5976C7.14966 9.90434 7.44628 9.46402 7.82674 9.25314C7.87106 9.22858 7.92592 9.24564 7.95237 9.28889L8.41779 10.05C8.45449 10.11 8.41938 10.1883 8.35077 10.2038C7.93269 10.2987 7.54074 10.4752 7.25595 10.6839C7.1841 10.7366 7.07573 10.6863 7.08411 10.5976Z';
                    const entertainmentSvgPath3 =
                        'M8.87602 12.5817C7.83548 13.5063 6.62355 13.8875 5.24022 13.7253C5.15171 13.715 5.09283 13.8143 5.15139 13.8815C6.4583 15.3807 8.82786 14.6354 9.03844 12.6589C9.04788 12.5703 8.94259 12.5226 8.87602 12.5817Z';
                    const entertainmentSvgPath4 =
                        'M7.44614 6.21277L7.58425 7.28119C7.81546 9.06988 8.72212 10.1007 9.83797 10.4673C10.1461 10.5686 10.4627 10.6178 10.7822 10.6139L11.5282 10.6047L11.5412 11.3507C11.5899 14.1467 10.2769 16.1579 8.21046 16.8078C6.57182 17.3232 4.8054 16.8631 3.32609 15.4814C1.86121 14.1131 0.669205 11.8458 0.0176102 8.6637C-0.102736 8.07598 0.411644 7.53923 1.01437 7.65665C2.72988 7.99084 4.72353 7.64071 6.49208 6.71315L7.44614 6.21277ZM1.69182 9.25715C2.3246 11.7455 3.30473 13.4088 4.34999 14.3852C5.50141 15.4607 6.71963 15.7043 7.76042 15.3769C8.91057 15.0152 9.866 13.9366 10.0207 12.0534C9.80054 12.0163 9.58317 11.9625 9.36975 11.8924C7.87151 11.4001 6.77285 10.1824 6.29465 8.46123C4.81433 9.07782 3.21516 9.36954 1.69182 9.25715Z';
                    const entertainmentSvgPath5 =
                        'M15.7158 4.27279C13.0793 4.39892 10.3869 3.54963 8.48697 1.96174C7.54652 4.35164 7.37049 6.27373 7.64883 7.67562C7.95538 9.21959 8.80154 10.1268 9.83797 10.4673C10.8765 10.8086 12.0931 10.5776 13.2112 9.51372C14.2391 8.53569 15.1838 6.84282 15.7158 4.27279ZM16.3968 2.70748C16.9707 2.63146 17.4373 3.13338 17.3482 3.68627C16.8265 6.92623 15.6929 9.22217 14.2454 10.5995C12.782 11.9919 11.0022 12.4288 9.36975 11.8924C7.73771 11.3562 6.57113 9.9529 6.17713 7.9685C5.78701 6.0036 6.1439 3.46773 7.47418 0.503888C7.71954 -0.0427647 8.45026 -0.179608 8.87153 0.267341C10.5861 2.08642 13.5679 3.08222 16.3968 2.70748Z';
                    const entertainmentSvgPath6 =
                        'M10.5817 5.67602C10.4262 3.78057 8.52309 3.75085 7.87928 5.14501C7.84193 5.22589 7.92912 5.30616 8.01383 5.2785C8.80319 5.02075 9.83137 5.32647 10.4089 5.76107C10.48 5.81462 10.589 5.76478 10.5817 5.67602Z';
                    const entertainmentSvgPath7 =
                        'M12.0829 6.1918C13.3351 4.75895 14.8841 5.86346 14.5731 7.36691C14.5551 7.45414 14.4372 7.46703 14.3855 7.39454C13.9036 6.71913 12.8945 6.35547 12.1714 6.36272C12.0823 6.36362 12.0243 6.2589 12.0829 6.1918Z';
                    const entertainmentSvgPath8 =
                        'M12.3786 8.8479C10.9934 8.99247 9.7864 8.59588 8.75773 7.65813C8.69192 7.59813 8.58603 7.64453 8.59433 7.7332C8.77971 9.71223 11.1396 10.4876 12.4655 9.00519C12.5249 8.93877 12.4673 8.83865 12.3786 8.8479Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, entertainmentSvgPath1) +
                            getPOISVGPath(color, entertainmentSvgPath2) +
                            getPOISVGPath(color, entertainmentSvgPath3) +
                            getPOISVGPath(color, entertainmentSvgPath4, true) +
                            getPOISVGPath(color, entertainmentSvgPath5, true) +
                            getPOISVGPath(color, entertainmentSvgPath6) +
                            getPOISVGPath(color, entertainmentSvgPath7) +
                            getPOISVGPath(color, entertainmentSvgPath8),
                    );
                    mapIcon = 'entertainment2.png';
                    break;
                case 'laundromats':
                    const laundromatsSvgPath1 =
                        'M11 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V16.5H12.5V3C12.5 2.17157 11.8284 1.5 11 1.5ZM3 0C1.34315 0 1.19209e-07 1.34315 1.19209e-07 3V17C1.19209e-07 17.5523 0.447716 18 1 18H13C13.5523 18 14 17.5523 14 17V3C14 1.34315 12.6569 0 11 0H3Z';
                    const laundromatsSvgPath2 =
                        'M7 13.5C8.38071 13.5 9.5 12.3807 9.5 11C9.5 9.61929 8.38071 8.5 7 8.5C5.61929 8.5 4.5 9.61929 4.5 11C4.5 12.3807 5.61929 13.5 7 13.5ZM7 15C9.20914 15 11 13.2091 11 11C11 8.79086 9.20914 7 7 7C4.79086 7 3 8.79086 3 11C3 13.2091 4.79086 15 7 15Z';
                    const laundromatsSvgPath3 = 'M14 5.5L1.31134e-07 5.5L0 4L14 4V5.5Z';
                    const laundromatsSvgPath4 =
                        'M4.02778 2.73922C4.02778 3.24348 3.62981 3.65226 3.13889 3.65226C2.64797 3.65226 2.25 3.24348 2.25 2.73922C2.25 2.23496 2.64797 1.82617 3.13889 1.82617C3.62981 1.82617 4.02778 2.23496 4.02778 2.73922Z';
                    const laundromatsSvgPath5 =
                        'M6.11111 2.73913C6.11111 3.24339 5.71314 3.65217 5.22222 3.65217C4.7313 3.65217 4.33333 3.24339 4.33333 2.73913C4.33333 2.23487 4.7313 1.82609 5.22222 1.82609C5.71314 1.82609 6.11111 2.23487 6.11111 2.73913Z';
                    width = 14;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, laundromatsSvgPath1, true) +
                            getPOISVGPath(color, laundromatsSvgPath2, true) +
                            getPOISVGPath(color, laundromatsSvgPath3, true) +
                            getPOISVGPath(color, laundromatsSvgPath4) +
                            getPOISVGPath(color, laundromatsSvgPath5),
                    );
                    mapIcon = 'laundromat.png';
                    break;
                case 'beaches':
                    const beachesSvgPath1 =
                        'M2.15954 4.74047C2.45642 4.69809 2.75957 4.69699 3.06839 4.74088C3.82097 4.84785 4.53322 5.21177 5.21256 5.76316C6.77119 4.85417 8.64608 5.11072 10.0915 6.40808C11.077 5.82834 12.1234 5.73357 13.0085 5.99718C12.3426 4.282 10.6739 2.62473 8.02008 2.33761C5.20682 2.03325 3.20086 3.2507 2.15954 4.74047ZM0.0325527 5.75168C0.793651 3.04279 3.76391 0.368386 8.18134 0.846307C12.3255 1.29467 14.6232 4.50209 14.825 7.27206C14.8589 7.738 14.5351 8.03992 14.2464 8.13754C13.9689 8.2314 13.5849 8.1936 13.3186 7.89335C12.8231 7.33461 11.6873 7.02749 10.5344 7.91632C10.1855 8.18536 9.68242 8.14639 9.38092 7.81447C8.2148 6.5307 6.7539 6.43329 5.6781 7.25356C5.34951 7.5041 4.88467 7.48419 4.57906 7.19964C3.91291 6.57941 3.34376 6.29509 2.8574 6.22597C2.39216 6.15984 1.90211 6.27623 1.34503 6.67018C1.034 6.89013 0.654258 6.86261 0.38792 6.69053C0.113162 6.51301 -0.0797705 6.15145 0.0325527 5.75168Z';
                    const beachesSvgPath2 =
                        'M7.60864 5.52122C8.02045 5.56577 8.31819 5.93573 8.27366 6.34755L7.42089 14.2337C7.37636 14.6456 7.00642 14.9433 6.59461 14.8987C6.1828 14.8542 5.88506 14.4842 5.92959 14.0724L6.78236 6.1862C6.82689 5.77439 7.19683 5.47667 7.60864 5.52122Z';
                    const beachesSvgPath3 =
                        'M6.53805 14.9614C6.94986 15.0059 7.24762 15.3759 7.20311 15.7877L7.09039 16.8307C7.04588 17.2425 6.67596 17.5403 6.26415 17.4957C5.85233 17.4512 5.55457 17.0813 5.59908 16.6694L5.71181 15.6264C5.75631 15.2146 6.12624 14.9169 6.53805 14.9614Z';
                    const beachesSvgPath4 =
                        'M8.52063 0.00441467C8.93244 0.0489683 9.23017 0.418927 9.18564 0.830739L9.10037 1.61936C9.05584 2.03117 8.6859 2.32889 8.27409 2.28434C7.86228 2.23979 7.56454 1.86983 7.60907 1.45802L7.69435 0.669396C7.73888 0.257583 8.10881 -0.040139 8.52063 0.00441467Z';
                    const beachesSvgPath5 =
                        'M13.6369 9.61048C14.0004 9.80904 14.1341 10.2647 13.9356 10.6282L11.9789 14.2105L12.8981 16.3142C13.064 16.6937 12.8908 17.1359 12.5112 17.3017C12.1316 17.4676 11.6895 17.2943 11.5236 16.9148L10.6537 14.9238H4.77926C4.68352 14.9238 4.59618 14.9785 4.55437 15.0646L3.64286 16.942C3.46196 17.3146 3.01323 17.4701 2.64061 17.2891C2.268 17.1082 2.11258 16.6595 2.29349 16.2869L3.205 14.4095C3.49771 13.8066 4.10905 13.4238 4.77926 13.4238H10.6995L12.6191 9.90919C12.8177 9.54566 13.2734 9.41193 13.6369 9.61048Z';
                    const beachesSvgPath6 =
                        'M9.9304 13.1484C9.74099 13.1484 9.56785 13.2554 9.48316 13.4248L8.96651 14.4584C8.84304 14.7054 8.54272 14.8055 8.29572 14.682C8.04871 14.5586 7.94857 14.2582 8.07204 14.0112L8.58869 12.9777C8.84275 12.4694 9.36218 12.1484 9.9304 12.1484H12.0878C12.364 12.1484 12.5878 12.3722 12.5878 12.6484C12.5878 12.9245 12.364 13.1484 12.0878 13.1484H9.9304Z';
                    width = 15;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, beachesSvgPath1, true) +
                            getPOISVGPath(color, beachesSvgPath2, true) +
                            getPOISVGPath(color, beachesSvgPath3, true) +
                            getPOISVGPath(color, beachesSvgPath4, true) +
                            getPOISVGPath(color, beachesSvgPath5, true) +
                            getPOISVGPath(color, beachesSvgPath6, true),
                    );
                    mapIcon = 'beach.png';
                    break;
                case 'military bases':
                    const militaryBasesSvgPath1 =
                        'M1.75 9.69737C1.61193 9.69737 1.5 9.8093 1.5 9.94737V16C1.5 16.1381 1.61193 16.25 1.75 16.25H4.60454L4.6326 13.5528C4.64258 12.5935 5.42311 11.8211 6.3825 11.8211H10.1532C11.1197 11.8211 11.9032 12.6046 11.9032 13.5711V16.25H14.75C14.8881 16.25 15 16.1381 15 16V9.94737C15 9.8093 14.8881 9.69737 14.75 9.69737H1.75ZM0 9.94737C0 8.98087 0.783501 8.19737 1.75 8.19737H14.75C15.7165 8.19737 16.5 8.98087 16.5 9.94737V16C16.5 16.9665 15.7165 17.75 14.75 17.75H11.6532C10.9629 17.75 10.4032 17.1904 10.4032 16.5V13.5711C10.4032 13.433 10.2913 13.3211 10.1532 13.3211H6.3825C6.24545 13.3211 6.13395 13.4314 6.13252 13.5685L6.10188 16.513C6.09475 17.1982 5.53723 17.75 4.85195 17.75H1.75C0.783503 17.75 0 16.9665 0 16V9.94737Z';
                    const militaryBasesSvgPath2 =
                        'M5.23483 5.84425C4.4473 6.76654 4 7.94027 4 8.94737C4 9.36158 3.66421 9.69737 3.25 9.69737C2.83579 9.69737 2.5 9.36158 2.5 8.94737C2.5 7.53866 3.10533 6.02818 4.09412 4.87021C5.08882 3.7053 6.53329 2.82895 8.25 2.82895C9.96671 2.82895 11.4112 3.70529 12.4059 4.87019C13.3947 6.02816 14 7.53863 14 8.94734C14 9.36155 13.6642 9.69734 13.25 9.69734C12.8358 9.69734 12.5 9.36155 12.5 8.94734C12.5 7.94024 12.0527 6.76652 11.2652 5.84424C10.4836 4.92889 9.42803 4.32895 8.25 4.32895C7.07197 4.32895 6.01645 4.9289 5.23483 5.84425Z';
                    const militaryBasesSvgPath3 =
                        'M7.75 0.6C7.75 0.268629 8.01863 0 8.35 0H10.2333C10.5647 0 10.8333 0.26863 10.8333 0.6V2.18947C10.8333 2.52084 10.5647 2.78947 10.2333 2.78947H8.75V3.5C8.75 3.77614 8.52614 4 8.25 4C7.97386 4 7.75 3.77614 7.75 3.5V0.6ZM8.75 1.78947H9.83333V1H8.75V1.78947Z';
                    width = 17;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, militaryBasesSvgPath1, true) +
                            getPOISVGPath(color, militaryBasesSvgPath2, true) +
                            getPOISVGPath(color, militaryBasesSvgPath3, true),
                    );
                    mapIcon = 'military-base.png';
                    break;
                case 'other':
                    width = 14;
                    const otherSvgPath1 =
                        'M1.99934 7.73595C2.00464 7.73595 2.00994 7.73595 2.01534 7.73585C2.03314 7.73585 2.05094 7.73585 2.06874 7.73585C2.08154 7.73585 2.09445 7.73585 2.10725 7.73585C2.14265 7.73575 2.17805 7.73575 2.21335 7.73575C2.25145 7.73575 2.28955 7.73575 2.32775 7.73565C2.41545 7.73555 2.50315 7.73555 2.59095 7.73555C2.63425 7.73555 2.67765 7.73545 2.72095 7.73545C2.86945 7.73535 3.01785 7.73535 3.16625 7.73525C3.17565 7.73525 3.18495 7.73525 3.19425 7.73525C3.20355 7.73525 3.21295 7.73525 3.22225 7.73525C3.24105 7.73525 3.25975 7.73525 3.27845 7.73525C3.28315 7.73525 3.28775 7.73525 3.29255 7.73525C3.44315 7.73525 3.59384 7.73515 3.74444 7.73505C3.90364 7.73485 4.06295 7.73475 4.22225 7.73475C4.23975 7.73475 4.25724 7.73475 4.27464 7.73475C4.27904 7.73475 4.28335 7.73475 4.28775 7.73475C4.35705 7.73475 4.42625 7.73475 4.49555 7.73465C4.56515 7.73455 4.63474 7.73455 4.70444 7.73455C4.74214 7.73455 4.77984 7.73455 4.81754 7.73445C4.85214 7.73445 4.88664 7.73445 4.92124 7.73445C4.93364 7.73455 4.94614 7.73445 4.95864 7.73445C5.06344 7.73405 5.14765 7.74205 5.22805 7.81655C5.28665 7.87935 5.30964 7.95525 5.30884 8.03965C5.30284 8.11575 5.26754 8.18385 5.21234 8.23585C5.15884 8.28005 5.10115 8.30365 5.03185 8.30295C5.02415 8.30295 5.02415 8.30295 5.01635 8.30295C4.99935 8.30305 4.98225 8.30295 4.96525 8.30285C4.95285 8.30285 4.94045 8.30295 4.92815 8.30295C4.89415 8.30295 4.86025 8.30295 4.82625 8.30285C4.78965 8.30275 4.75304 8.30275 4.71644 8.30275C4.65294 8.30275 4.58954 8.30275 4.52604 8.30265C4.45954 8.30255 4.39304 8.30245 4.32654 8.30245C4.32034 8.30245 4.32034 8.30245 4.31394 8.30245C4.29294 8.30245 4.27195 8.30245 4.25095 8.30245C4.10215 8.30235 3.95325 8.30225 3.80445 8.30205C3.65995 8.30195 3.51534 8.30175 3.37084 8.30175C3.36414 8.30175 3.36414 8.30175 3.35734 8.30175C3.31254 8.30165 3.26775 8.30165 3.22305 8.30165C3.13185 8.30155 3.04064 8.30155 2.94944 8.30145C2.94524 8.30145 2.94104 8.30145 2.93674 8.30145C2.65694 8.30135 2.37705 8.30105 2.09715 8.30075C2.09595 8.30565 2.09474 8.31065 2.09344 8.31575C2.09104 8.32555 2.09104 8.32555 2.08854 8.33545C2.08694 8.34195 2.08534 8.34835 2.08364 8.35505C2.07904 8.37305 2.07395 8.39065 2.06795 8.40815C2.06595 8.41425 2.06394 8.42025 2.06184 8.42645C2.05974 8.43275 2.05764 8.43905 2.05544 8.44545C2.05314 8.45225 2.05084 8.45905 2.04854 8.46605C2.04364 8.48055 2.03875 8.49505 2.03395 8.50945C2.02215 8.54435 2.01045 8.57925 1.99885 8.61405C1.99485 8.62585 1.99095 8.63755 1.98705 8.64925C1.96625 8.71125 1.94595 8.77335 1.92575 8.83545C1.88725 8.95435 1.84825 9.07305 1.80915 9.19175C1.76095 9.33795 1.71274 9.48425 1.66504 9.63065C1.63424 9.72525 1.60334 9.81975 1.57234 9.91435C1.56734 9.92965 1.56235 9.94485 1.55735 9.96015C1.54525 9.99705 1.53324 10.0338 1.52114 10.0707C1.52484 10.0707 1.52844 10.0707 1.53224 10.0707C1.92974 10.0709 2.32724 10.0713 2.72474 10.0717C2.73074 10.0717 2.73665 10.0717 2.74275 10.0717C2.87175 10.0719 3.00084 10.072 3.12984 10.0721C3.19314 10.0722 3.25634 10.0723 3.31964 10.0723C3.32594 10.0724 3.33225 10.0724 3.33875 10.0724C3.54285 10.0726 3.74695 10.0726 3.95115 10.0728C4.16085 10.0729 4.37055 10.0732 4.58035 10.0734C4.60995 10.0735 4.63954 10.0734 4.66924 10.0735C4.67794 10.0735 4.67794 10.0735 4.68684 10.0735C4.78074 10.0736 4.87464 10.0737 4.96844 10.0738C5.06284 10.0738 5.15715 10.0739 5.25155 10.074C5.30765 10.0741 5.36365 10.0742 5.41975 10.0742C5.45725 10.0741 5.49465 10.0741 5.53215 10.0742C5.55345 10.0743 5.57474 10.0743 5.59614 10.0742C5.61914 10.0742 5.64214 10.0744 5.66514 10.0745C5.67174 10.0744 5.67835 10.0743 5.68515 10.0742C5.76315 10.0749 5.82635 10.0963 5.88475 10.149C5.94395 10.2111 5.96964 10.2851 5.96934 10.3695C5.96694 10.4529 5.93085 10.5204 5.87075 10.5772C5.80805 10.6288 5.74404 10.6436 5.66424 10.6429C5.65334 10.643 5.65335 10.643 5.64205 10.643C5.62195 10.643 5.60175 10.643 5.58155 10.6429C5.55975 10.6428 5.53795 10.6428 5.51605 10.6428C5.47835 10.6428 5.44054 10.6428 5.40284 10.6427C5.34824 10.6425 5.29365 10.6425 5.23905 10.6425C5.15045 10.6424 5.06184 10.6423 4.97324 10.6421C4.88724 10.642 4.80125 10.6418 4.71525 10.6418C4.70995 10.6418 4.70465 10.6417 4.69915 10.6416C4.67255 10.6416 4.64585 10.6416 4.61925 10.6416C4.39855 10.6414 4.17784 10.6412 3.95714 10.6408C3.95724 10.6474 3.95725 10.654 3.95735 10.6609C3.95715 10.6794 3.95574 10.6934 3.95094 10.7111C3.94964 10.7164 3.94825 10.7217 3.94685 10.7271C3.94445 10.7357 3.94445 10.7357 3.94215 10.7444C3.94045 10.7506 3.93885 10.7567 3.93715 10.7631C3.93165 10.784 3.92605 10.8048 3.92045 10.8256C3.91635 10.8408 3.91235 10.8559 3.90825 10.8711C3.89825 10.9088 3.88815 10.9467 3.87805 10.9844C3.86945 11.0161 3.86094 11.0479 3.85244 11.0797C3.82394 11.1861 3.79544 11.2926 3.76684 11.399C3.73524 11.5163 3.70375 11.6337 3.67235 11.7511C3.66255 11.7878 3.65265 11.8244 3.64285 11.8611C3.60985 11.9843 3.57685 12.1074 3.54395 12.2307C3.53905 12.249 3.53415 12.2675 3.52925 12.2859C3.52685 12.2948 3.52685 12.2948 3.52445 12.3039C3.52135 12.3157 3.51815 12.3275 3.51505 12.3394C3.50585 12.3735 3.49675 12.4077 3.48765 12.4419C3.48215 12.4629 3.47655 12.4837 3.47095 12.5047C3.46835 12.5143 3.46585 12.524 3.46325 12.5336C3.45975 12.5468 3.45625 12.5601 3.45275 12.5732C3.45075 12.5806 3.44884 12.5878 3.44674 12.5954C3.44114 12.6147 3.44114 12.6148 3.42914 12.6448C5.74574 12.6448 8.06235 12.6448 10.4491 12.6448C10.4333 12.5735 10.4174 12.5021 10.4011 12.4287C10.3886 12.3712 10.3762 12.3137 10.3638 12.2561C10.3593 12.235 10.3547 12.214 10.3502 12.1929C10.3414 12.1522 10.3327 12.1115 10.3239 12.0707C10.3137 12.0233 10.3035 11.9759 10.2933 11.9285C10.2734 11.836 10.2535 11.7433 10.2336 11.6507C10.2196 11.5856 10.2056 11.5205 10.1916 11.4554C10.1726 11.367 10.1536 11.2786 10.1346 11.1902C10.1287 11.1629 10.1228 11.1356 10.117 11.1083C10.1091 11.0718 10.1013 11.0352 10.0934 10.9986C10.0906 10.9854 10.0877 10.9722 10.0849 10.959C10.0786 10.9297 10.0723 10.9004 10.066 10.8711C10.0614 10.8494 10.0567 10.8278 10.052 10.8062C10.0498 10.7959 10.0476 10.7857 10.0454 10.7755C10.0443 10.7709 10.0433 10.7663 10.0423 10.7616C10.0336 10.7213 10.0279 10.6806 10.0411 10.6408C10.0366 10.6408 10.0321 10.6408 10.0274 10.6408C9.75885 10.6413 9.49024 10.6417 9.22164 10.642C9.18934 10.642 9.15704 10.6421 9.12484 10.6421C9.11844 10.6421 9.11195 10.6421 9.10535 10.6421C9.00145 10.6422 8.89745 10.6424 8.79355 10.6426C8.68685 10.6428 8.58014 10.643 8.47344 10.643C8.40764 10.6431 8.34184 10.6432 8.27594 10.6434C8.23084 10.6435 8.18565 10.6435 8.14055 10.6435C8.11445 10.6435 8.08845 10.6435 8.06245 10.6436C8.03855 10.6437 8.01464 10.6438 7.99074 10.6437C7.98214 10.6437 7.97355 10.6436 7.96495 10.6437C7.87055 10.6445 7.80195 10.6192 7.73265 10.5549C7.67685 10.4958 7.65605 10.4272 7.65665 10.3471C7.65895 10.2831 7.67985 10.2289 7.71915 10.1787C7.72185 10.175 7.72445 10.1713 7.72715 10.1675C7.76735 10.1152 7.82395 10.0897 7.88715 10.0768C7.91235 10.0744 7.93724 10.0744 7.96254 10.0746C7.96994 10.0745 7.97725 10.0745 7.98485 10.0745C8.00515 10.0745 8.02544 10.0745 8.04574 10.0746C8.06784 10.0746 8.09005 10.0746 8.11215 10.0746C8.15085 10.0745 8.18964 10.0746 8.22834 10.0746C8.28594 10.0747 8.34354 10.0747 8.40124 10.0747C8.49814 10.0747 8.59505 10.0748 8.69195 10.0749C8.78795 10.075 8.88385 10.075 8.97985 10.0751C8.98575 10.0751 8.99174 10.0751 8.99794 10.0751C9.02824 10.0751 9.05855 10.0751 9.08885 10.0751C9.30345 10.0751 9.51805 10.0752 9.73275 10.0754C9.94125 10.0756 10.1497 10.0757 10.3582 10.0758C10.3678 10.0758 10.3678 10.0758 10.3776 10.0758C10.4422 10.0758 10.5067 10.0758 10.5713 10.0759C10.7028 10.0759 10.8343 10.076 10.9658 10.076C10.9748 10.076 10.9748 10.076 10.9841 10.076C11.3878 10.0762 11.7914 10.0765 12.1951 10.0768C12.1753 10.0028 12.1556 9.92875 12.1358 9.85485C12.1266 9.82045 12.1174 9.78605 12.1082 9.75165C12.0571 9.56055 12.006 9.36935 11.9547 9.17825C11.9532 9.17235 11.9516 9.16635 11.9499 9.16025C11.9355 9.10635 11.921 9.05245 11.9066 8.99855C11.8828 8.91005 11.8591 8.82165 11.8354 8.73315C11.8329 8.72355 11.8329 8.72355 11.8302 8.71385C11.82 8.67555 11.8097 8.63735 11.7995 8.59905C11.7906 8.56585 11.7817 8.53265 11.7728 8.49945C11.7556 8.43525 11.7383 8.37095 11.7211 8.30675C11.7114 8.30675 11.7114 8.30675 11.7016 8.30675C11.4173 8.30655 11.133 8.30635 10.8487 8.30605C10.8423 8.30605 10.8423 8.30605 10.8357 8.30605C10.7421 8.30585 10.6486 8.30575 10.555 8.30565C10.5091 8.30555 10.4632 8.30555 10.4174 8.30545C10.4128 8.30545 10.4082 8.30545 10.4035 8.30545C10.2556 8.30525 10.1076 8.30515 9.95974 8.30505C9.80764 8.30505 9.65564 8.30485 9.50354 8.30465C9.48204 8.30455 9.46055 8.30455 9.43915 8.30455C9.43485 8.30455 9.43065 8.30445 9.42625 8.30445C9.35825 8.30435 9.29025 8.30435 9.22225 8.30435C9.15375 8.30435 9.08535 8.30425 9.01695 8.30415C8.97995 8.30405 8.94284 8.30395 8.90584 8.30405C8.87184 8.30405 8.83794 8.30405 8.80394 8.30385C8.79174 8.30385 8.77944 8.30385 8.76714 8.30395C8.68304 8.30425 8.61744 8.29705 8.54714 8.24675C8.54114 8.24235 8.53504 8.23805 8.52874 8.23355C8.48164 8.19255 8.45265 8.13305 8.43915 8.07275C8.43375 7.98395 8.44204 7.91065 8.49914 7.83875C8.51374 7.82255 8.51375 7.82255 8.52915 7.80875C8.53235 7.80575 8.53545 7.80285 8.53865 7.79975C8.59675 7.74695 8.66115 7.73475 8.73805 7.73515C8.74375 7.73515 8.74935 7.73515 8.75515 7.73515C8.77395 7.73505 8.79284 7.73515 8.81164 7.73515C8.82524 7.73515 8.83894 7.73515 8.85264 7.73505C8.89014 7.73505 8.92754 7.73505 8.96504 7.73505C9.00134 7.73505 9.03765 7.73505 9.07395 7.73495C9.15735 7.73495 9.24075 7.73485 9.32415 7.73495C9.38845 7.73495 9.45285 7.73495 9.51725 7.73485C9.52655 7.73485 9.53574 7.73485 9.54504 7.73485C9.55894 7.73485 9.57294 7.73485 9.58684 7.73485C9.71654 7.73485 9.84624 7.73475 9.97584 7.73485C9.98314 7.73485 9.98315 7.73485 9.99065 7.73485C10.0154 7.73485 10.0401 7.73485 10.0649 7.73485C10.0698 7.73485 10.0747 7.73485 10.0798 7.73485C10.0898 7.73485 10.0997 7.73485 10.1096 7.73485C10.2644 7.73485 10.4192 7.73485 10.5739 7.73475C10.7479 7.73455 10.9218 7.73455 11.0957 7.73455C11.1143 7.73455 11.1328 7.73455 11.1514 7.73455C11.1582 7.73455 11.1582 7.73455 11.1652 7.73455C11.2341 7.73455 11.3031 7.73455 11.372 7.73445C11.4503 7.73435 11.5287 7.73435 11.6071 7.73445C11.6471 7.73445 11.6871 7.73445 11.7271 7.73445C11.7637 7.73435 11.8003 7.73435 11.8369 7.73445C11.8502 7.73445 11.8634 7.73445 11.8766 7.73445C11.9832 7.73405 12.0705 7.73955 12.1516 7.81625C12.2057 7.87335 12.2233 7.93255 12.2388 8.00785C12.2502 8.06125 12.2643 8.11395 12.2784 8.16665C12.2813 8.17765 12.2843 8.18865 12.2872 8.19965C12.2951 8.22925 12.303 8.25885 12.3109 8.28855C12.3176 8.31365 12.3243 8.33865 12.331 8.36375C12.3849 8.56605 12.4392 8.76825 12.4936 8.97045C12.5357 9.12655 12.5775 9.28265 12.6192 9.43885C12.6306 9.48145 12.642 9.52415 12.6534 9.56675C12.6548 9.57205 12.6562 9.57725 12.6577 9.58265C12.6894 9.70135 12.7213 9.82005 12.7531 9.93875C12.7982 10.1067 12.8432 10.2747 12.8881 10.4428C12.9327 10.6094 12.9773 10.776 13.022 10.9426C13.0247 10.9527 13.0274 10.9628 13.0301 10.9729C13.0356 10.9933 13.0411 11.0137 13.0465 11.0341C13.0486 11.0418 13.0486 11.0417 13.0507 11.0495C13.0535 11.0598 13.0562 11.0702 13.059 11.0805C13.0945 11.2125 13.1299 11.3445 13.1652 11.4765C13.1669 11.4826 13.1685 11.4887 13.1701 11.4949C13.209 11.6399 13.2479 11.7849 13.2866 11.93C13.2892 11.9396 13.2892 11.9396 13.2918 11.9494C13.3073 12.0073 13.3227 12.0651 13.3382 12.123C13.3737 12.256 13.4093 12.389 13.4451 12.5219C13.4466 12.5275 13.4481 12.533 13.4497 12.5387C13.4638 12.5912 13.4779 12.6436 13.4921 12.6961C13.4971 12.7146 13.5021 12.7332 13.5072 12.7518C13.5095 12.7603 13.5118 12.7687 13.5141 12.7773C13.5172 12.7888 13.5203 12.8005 13.5234 12.812C13.5252 12.8184 13.5269 12.8248 13.5287 12.8314C13.5493 12.9121 13.5474 12.9973 13.5047 13.0706C13.4524 13.1466 13.3894 13.1911 13.2991 13.2088C13.2687 13.2112 13.2384 13.2112 13.2079 13.211C13.1987 13.211 13.1895 13.2111 13.1804 13.2111C13.1552 13.2111 13.13 13.2111 13.1048 13.211C13.0773 13.211 13.0498 13.211 13.0223 13.2111C12.9739 13.2111 12.9255 13.2111 12.8771 13.2111C12.8046 13.211 12.7321 13.211 12.6597 13.211C12.5362 13.2111 12.4127 13.2111 12.2892 13.211C12.164 13.2109 12.0389 13.2109 11.9137 13.2109C11.9058 13.2109 11.8979 13.2109 11.8898 13.2109C11.8576 13.2109 11.8254 13.2109 11.7932 13.2109C11.7025 13.211 11.6118 13.211 11.5211 13.211C11.5169 13.211 11.5128 13.211 11.5085 13.211C11.3035 13.211 11.0986 13.2109 10.8936 13.2109C10.8215 13.2108 10.7493 13.2108 10.6772 13.2108C10.6727 13.2108 10.6682 13.2108 10.6636 13.2108C10.4558 13.2107 10.248 13.2106 10.0401 13.2106C10.0266 13.2106 10.013 13.2106 9.99945 13.2106C9.91745 13.2106 9.83544 13.2106 9.75354 13.2106C9.54974 13.2106 9.34595 13.2106 9.14225 13.2106C9.13755 13.2106 9.13294 13.2106 9.12814 13.2106C8.82764 13.2106 8.52724 13.2106 8.22674 13.2106C8.22194 13.2106 8.21714 13.2106 8.21224 13.2106C8.05644 13.2105 7.90065 13.2104 7.74485 13.2104C7.59295 13.2103 7.44115 13.2104 7.28935 13.2104C7.28205 13.2104 7.28205 13.2104 7.27465 13.2104C6.81325 13.2103 6.35195 13.2102 5.89065 13.2102C5.86625 13.2102 5.84184 13.2102 5.81744 13.2102C5.74914 13.2102 5.68094 13.2102 5.61274 13.2102C5.60294 13.2102 5.59324 13.2102 5.58354 13.2102C5.57874 13.2102 5.57385 13.2102 5.56895 13.2102C5.53015 13.2102 5.49125 13.2102 5.45245 13.2102C5.42825 13.2102 5.40394 13.2102 5.37974 13.2102C5.08434 13.2102 4.78885 13.2102 4.49345 13.2101C4.48875 13.2101 4.48415 13.2101 4.47935 13.2101C4.26195 13.2101 4.04464 13.2101 3.82724 13.2101C3.82274 13.2101 3.81815 13.2101 3.81355 13.2101C3.72275 13.2101 3.63185 13.2099 3.54105 13.2099C3.35135 13.2099 3.16164 13.2099 2.97194 13.2099C2.94924 13.2099 2.92665 13.2099 2.90405 13.2099C2.89735 13.2099 2.89734 13.2099 2.89044 13.2099C2.53704 13.2098 2.18354 13.2098 1.83015 13.2097C1.79405 13.2097 1.75785 13.2097 1.72175 13.2097C1.71385 13.2097 1.70595 13.2097 1.69785 13.2097C1.57305 13.2096 1.44815 13.2097 1.32335 13.2097C1.20065 13.2097 1.07805 13.2097 0.955345 13.2097C0.883345 13.2096 0.811345 13.2096 0.739445 13.2096C0.691645 13.2096 0.643845 13.2096 0.596145 13.2096C0.569045 13.2096 0.541945 13.2096 0.514845 13.2096C0.490145 13.2096 0.465545 13.2096 0.440945 13.2095C0.432145 13.2095 0.423345 13.2095 0.414545 13.2096C0.185445 13.2099 0.185445 13.2098 0.099145 13.1367C0.095245 13.1334 0.0914454 13.1302 0.0874454 13.1268C0.0327454 13.0763 0.00414506 13.0117 0.000145061 12.938C-0.000954939 12.8949 0.00414553 12.8565 0.0173455 12.8155C0.0196455 12.8079 0.0196452 12.8079 0.0220452 12.8002C0.0276452 12.7824 0.0334456 12.7646 0.0391456 12.7468C0.0425456 12.7363 0.0425454 12.7363 0.0460454 12.7256C0.0635454 12.6715 0.081345 12.6176 0.099145 12.5636C0.106845 12.5402 0.114545 12.5167 0.122245 12.4933C0.125445 12.4838 0.128545 12.4743 0.131645 12.4648C0.134045 12.4577 0.134045 12.4578 0.136345 12.4506C0.141045 12.4364 0.145745 12.422 0.150445 12.4077C0.175345 12.3322 0.200145 12.2568 0.224745 12.1813C0.267745 12.0497 0.310945 11.9182 0.354145 11.7868C0.395445 11.661 0.436745 11.5353 0.477945 11.4095C0.516345 11.292 0.554845 11.1745 0.593445 11.057C0.596045 11.0489 0.598745 11.0408 0.601445 11.0327C0.604045 11.0245 0.606745 11.0163 0.609445 11.0082C0.613445 10.996 0.617445 10.9838 0.621445 10.9716C0.624045 10.9635 0.626745 10.9555 0.629445 10.9474C0.658845 10.8578 0.688146 10.7682 0.717546 10.6786C0.720046 10.6711 0.722445 10.6636 0.725045 10.6559C0.737445 10.618 0.749845 10.5801 0.762245 10.5422C0.777245 10.4966 0.792145 10.451 0.807145 10.4053C0.809045 10.3997 0.809045 10.3997 0.810845 10.3939C0.820945 10.3634 0.830945 10.3328 0.840945 10.3023C0.849645 10.2756 0.858446 10.2489 0.867146 10.2222C0.868446 10.2184 0.869645 10.2146 0.870945 10.2108C0.887145 10.1614 0.903345 10.112 0.919545 10.0626C0.974345 9.89525 1.02925 9.72795 1.08415 9.56065C1.13885 9.39385 1.19355 9.22705 1.24825 9.06015C1.26325 9.01455 1.27815 8.96895 1.29315 8.92325C1.29435 8.91955 1.29565 8.91575 1.29685 8.91185C1.30315 8.89275 1.30945 8.87365 1.31565 8.85465C1.32695 8.82025 1.33815 8.78595 1.34945 8.75165C1.35565 8.73255 1.36195 8.71355 1.36815 8.69445C1.37065 8.68685 1.37314 8.67925 1.37564 8.67155C1.38064 8.65635 1.38565 8.64105 1.39065 8.62585C1.39195 8.62205 1.39315 8.61825 1.39445 8.61445C1.39695 8.60675 1.39945 8.59915 1.40195 8.59155C1.40815 8.57245 1.41444 8.55335 1.42064 8.53435C1.43304 8.49645 1.44554 8.45855 1.45794 8.42065C1.48144 8.34925 1.50485 8.27775 1.52785 8.20605C1.53735 8.17635 1.54695 8.14675 1.55655 8.11705C1.56435 8.09285 1.57205 8.06875 1.57975 8.04455C1.58565 8.02605 1.59164 8.00765 1.59764 7.98915C1.60074 7.97935 1.60074 7.97935 1.60384 7.96925C1.62854 7.89395 1.67394 7.82575 1.74444 7.78655C1.79404 7.76325 1.84585 7.75235 1.89995 7.74505C1.91655 7.74315 1.91655 7.74315 1.92995 7.73965C1.95315 7.73575 1.97594 7.73585 1.99934 7.73595ZM1.32915 10.6408C1.25315 10.8688 1.25314 10.8688 1.17834 11.0972C1.14694 11.1939 1.11515 11.2904 1.08335 11.3869C1.06925 11.4299 1.05505 11.4729 1.04095 11.5159C1.03945 11.5206 1.03785 11.5253 1.03625 11.5301C1.00745 11.6178 0.978745 11.7054 0.950045 11.7931C0.915245 11.8994 0.880445 12.0057 0.845545 12.1119C0.828445 12.1643 0.811246 12.2167 0.794046 12.2691C0.781446 12.3074 0.768845 12.3458 0.756245 12.3842C0.744745 12.4193 0.733145 12.4544 0.721645 12.4896C0.717445 12.5024 0.713245 12.5153 0.708945 12.5282C0.703245 12.5457 0.697445 12.5632 0.691745 12.5807C0.690045 12.5858 0.688345 12.5911 0.686545 12.5964C0.678245 12.6201 0.678245 12.6201 0.675145 12.6448C1.38995 12.6448 2.10475 12.6448 2.84115 12.6448C2.86215 12.5715 2.88294 12.4983 2.90254 12.4247C2.90474 12.4165 2.90475 12.4165 2.90695 12.4082C2.90845 12.4026 2.90994 12.3969 2.91144 12.3911C2.91464 12.379 2.91795 12.3671 2.92115 12.355C2.92795 12.3295 2.93475 12.304 2.94155 12.2784C2.95235 12.2379 2.96314 12.1974 2.97404 12.1568C2.97584 12.15 2.97764 12.1431 2.97954 12.136C2.98324 12.1222 2.98695 12.1085 2.99055 12.0947C2.99615 12.0739 3.00165 12.053 3.00725 12.0322C3.03895 11.9134 3.07074 11.7946 3.10264 11.6759C3.11464 11.6313 3.12665 11.5869 3.13855 11.5423C3.14055 11.535 3.14054 11.535 3.14254 11.5275C3.18074 11.3851 3.21884 11.2425 3.25694 11.1001C3.26094 11.0848 3.26505 11.0696 3.26915 11.0544C3.27445 11.0346 3.27974 11.0147 3.28504 10.9949C3.29764 10.9476 3.31034 10.9004 3.32314 10.8531C3.32934 10.8302 3.33555 10.8073 3.34175 10.7843C3.34475 10.7733 3.34765 10.7624 3.35065 10.7514C3.35485 10.7362 3.35894 10.721 3.36304 10.7058C3.36424 10.7013 3.36544 10.6968 3.36674 10.6921C3.37154 10.6745 3.37514 10.6592 3.37514 10.6408C2.69994 10.6408 2.02485 10.6408 1.32915 10.6408ZM10.5991 10.6408C10.6669 10.9581 10.7346 11.2754 10.8028 11.5926C10.8089 11.621 10.815 11.6493 10.8211 11.6777C10.8221 11.6825 10.8231 11.6872 10.8242 11.6922C10.8263 11.7019 10.8284 11.7116 10.8305 11.7213C10.8438 11.7836 10.8572 11.8457 10.8706 11.9079C10.8936 12.0148 10.9165 12.1217 10.9394 12.2286C10.948 12.2684 10.9565 12.3082 10.965 12.348C10.9715 12.378 10.9779 12.4079 10.9844 12.438C10.9902 12.4652 10.996 12.4924 11.0019 12.5196C11.0039 12.5293 11.006 12.539 11.0081 12.5487C11.0109 12.5617 11.0137 12.5747 11.0165 12.5877C11.018 12.5949 11.0195 12.602 11.0211 12.6094C11.0249 12.627 11.0249 12.627 11.0311 12.6448C11.6429 12.6448 12.2548 12.6448 12.8851 12.6448C12.8775 12.6065 12.8695 12.569 12.8594 12.5315C12.858 12.5265 12.8567 12.5216 12.8553 12.5164C12.8509 12.4999 12.8464 12.4832 12.842 12.4667C12.8388 12.4548 12.8356 12.4429 12.8324 12.431C12.8238 12.3988 12.8152 12.3668 12.8065 12.3346C12.7974 12.3005 12.7882 12.2663 12.7791 12.2321C12.7639 12.1755 12.7487 12.1189 12.7335 12.0623C12.7127 11.9847 12.6919 11.9072 12.6712 11.8296C12.644 11.7281 12.6167 11.6265 12.5895 11.525C12.5656 11.4357 12.5416 11.3465 12.5177 11.2571C12.5071 11.2174 12.4964 11.1777 12.4858 11.1379C12.4774 11.1064 12.4689 11.0747 12.4605 11.0432C12.4526 11.0138 12.4447 10.9845 12.4369 10.9551C12.434 10.9445 12.4312 10.9338 12.4283 10.9231C12.4031 10.8288 12.3771 10.7349 12.3511 10.6408C11.773 10.6408 11.1948 10.6408 10.5991 10.6408Z';
                    const otherSvgPath2 =
                        'M6.71765 0.000625473C6.72435 0.000625473 6.73105 0.000625337 6.73805 0.000525337C6.75225 0.000525337 6.76645 0.000425201 6.78065 0.000425201C6.80185 0.000325201 6.82295 0.000224658 6.84415 2.46577e-05C6.96855 -0.000575342 7.09145 0.00972532 7.21315 0.0363253C7.22035 0.0379253 7.22755 0.039425 7.23485 0.041025C7.55595 0.111325 7.84775 0.251726 8.10375 0.457826C8.10735 0.460726 8.11095 0.463625 8.11465 0.466625C8.16775 0.509825 8.21655 0.557425 8.26505 0.605625C8.26795 0.608525 8.27085 0.611425 8.27385 0.614325C8.31395 0.654125 8.35065 0.695625 8.38575 0.739825C8.39175 0.747125 8.39785 0.754325 8.40385 0.761625C8.50215 0.880425 8.58375 1.01433 8.64985 1.15353C8.65385 1.16183 8.65795 1.17022 8.66205 1.17852C8.89195 1.64662 8.89795 2.20643 8.73415 2.69513C8.66105 2.90633 8.55065 3.10433 8.40975 3.27783C8.40325 3.28623 8.40325 3.28623 8.39645 3.29463C8.36965 3.32813 8.34145 3.36023 8.31205 3.39153C8.30055 3.40393 8.28955 3.41622 8.27965 3.42992C8.27575 3.43482 8.27575 3.43482 8.27175 3.43982C8.26785 3.43982 8.26385 3.43982 8.25975 3.43982C8.25835 3.44332 8.25695 3.44672 8.25545 3.45032C8.24615 3.46682 8.23515 3.47652 8.22075 3.48902C8.21535 3.49372 8.20995 3.49853 8.20435 3.50333C8.19895 3.50813 8.19345 3.51292 8.18775 3.51782C8.17825 3.52662 8.16875 3.53533 8.15925 3.54413C7.99755 3.68943 7.80865 3.80163 7.61065 3.88953C7.60415 3.89243 7.59765 3.89532 7.59085 3.89832C7.58475 3.90102 7.57855 3.90373 7.57215 3.90653C7.56665 3.90893 7.56115 3.91142 7.55545 3.91392C7.54025 3.91972 7.52575 3.92292 7.50975 3.92582C7.50985 3.93032 7.50985 3.93473 7.50985 3.93933C7.51055 4.42133 7.51135 4.90343 7.51205 5.38543C7.51205 5.39263 7.51205 5.39982 7.51205 5.40722C7.51225 5.56362 7.51245 5.72013 7.51275 5.87653C7.51285 5.95323 7.51295 6.02992 7.51305 6.10662C7.51305 6.11812 7.51305 6.11813 7.51305 6.12983C7.51335 6.37733 7.51375 6.62483 7.51415 6.87233C7.51455 7.12673 7.51495 7.38102 7.51525 7.63532C7.51535 7.67122 7.51535 7.70712 7.51545 7.74302C7.51545 7.75012 7.51545 7.75713 7.51545 7.76443C7.51555 7.87833 7.51575 7.99212 7.51595 8.10592C7.51615 8.22032 7.51635 8.33473 7.51645 8.44913C7.51655 8.51713 7.51665 8.58513 7.51685 8.65313C7.51695 8.69853 7.51695 8.74392 7.51695 8.78942C7.51695 8.81522 7.51705 8.84113 7.51715 8.86703C7.51715 8.89063 7.51715 8.91413 7.51715 8.93773C7.51715 8.94613 7.51715 8.95463 7.51725 8.96313C7.51755 9.03213 7.50985 9.08953 7.48165 9.15263C7.47935 9.15793 7.47705 9.16322 7.47465 9.16862C7.44925 9.22622 7.42225 9.28313 7.39535 9.34013C7.36815 9.39783 7.34145 9.45563 7.31515 9.51373C7.31335 9.51783 7.31145 9.52183 7.30965 9.52603C7.30215 9.54253 7.29465 9.55912 7.28715 9.57562C7.27315 9.60642 7.25915 9.63722 7.24515 9.66792C7.24305 9.67242 7.24105 9.67693 7.23885 9.68163C7.22865 9.70403 7.21835 9.72643 7.20805 9.74883C7.19015 9.78803 7.17225 9.82733 7.15475 9.86683C7.07455 10.0477 7.07455 10.0477 6.97355 10.0871C6.89555 10.1113 6.79065 10.1156 6.71575 10.0799C6.64125 10.0329 6.60445 9.96623 6.56665 9.88913C6.56325 9.88223 6.55985 9.87533 6.55635 9.86823C6.53295 9.82083 6.50995 9.77313 6.48725 9.72543C6.45985 9.66783 6.43185 9.61043 6.40395 9.55313C6.27485 9.28833 6.27485 9.28833 6.22315 9.17813C6.21805 9.16713 6.21295 9.15633 6.20775 9.14543C6.20475 9.13883 6.20165 9.13223 6.19845 9.12543C6.19575 9.11963 6.19305 9.11393 6.19035 9.10793C6.17745 9.07613 6.17725 9.04762 6.17775 9.01382C6.17385 9.01382 6.16985 9.01382 6.16575 9.01382C6.16385 7.34272 6.16185 5.67163 6.15975 3.94983C6.12015 3.93603 6.08055 3.92213 6.03975 3.90783C6.01845 3.89953 5.99745 3.89112 5.97645 3.88202C5.97125 3.87972 5.96615 3.87752 5.96075 3.87522C5.69315 3.75712 5.44335 3.57312 5.25375 3.34982C5.24905 3.34442 5.24425 3.33893 5.23925 3.33333C4.98175 3.03803 4.82415 2.66273 4.77375 2.27583C4.77275 2.26863 4.77275 2.26862 4.77165 2.26122C4.74935 2.10342 4.75115 1.92942 4.77375 1.77182C4.77475 1.76522 4.77565 1.75852 4.77665 1.75162C4.84545 1.27372 5.07945 0.813825 5.45175 0.499825C5.45695 0.495425 5.46205 0.491025 5.46745 0.486525C5.78185 0.219925 6.16935 0.0507248 6.57975 0.00782476C6.58475 0.00732476 6.58965 0.00682463 6.59475 0.00632463C6.63575 0.00222463 6.67645 0.000825473 6.71765 0.000625473ZM5.96175 0.823825C5.95585 0.828125 5.94995 0.832425 5.94385 0.836925C5.86235 0.897025 5.77925 0.961525 5.71405 1.03973C5.70655 1.04863 5.69875 1.05723 5.69065 1.06573C5.61325 1.14733 5.55315 1.24123 5.49975 1.33983C5.49755 1.34393 5.49535 1.34803 5.49305 1.35233C5.38245 1.55923 5.32895 1.78433 5.32995 2.01823C5.32995 2.02393 5.32995 2.02963 5.32995 2.03553C5.33025 2.12073 5.33255 2.20413 5.34975 2.28783C5.35105 2.29393 5.35225 2.29993 5.35355 2.30603C5.40745 2.56243 5.52255 2.79503 5.69775 2.98983C5.70075 2.99323 5.70375 2.99652 5.70675 3.00002C5.95415 3.27772 6.31615 3.45832 6.68875 3.48112C7.03305 3.49672 7.36915 3.41822 7.65375 3.21782C7.65735 3.21532 7.66105 3.21282 7.66475 3.21022C7.73015 3.16372 7.78845 3.11182 7.84575 3.05582C7.85165 3.05032 7.85745 3.04473 7.86325 3.03913C7.89845 3.00493 7.92945 2.96842 7.95975 2.92982C7.96445 2.92412 7.96915 2.91832 7.97395 2.91232C8.14125 2.70182 8.24035 2.44602 8.27175 2.17982C8.27295 2.17032 8.27295 2.17033 8.27415 2.16063C8.29955 1.90533 8.25365 1.63583 8.13975 1.40583C8.13725 1.40063 8.13465 1.39532 8.13205 1.38982C8.00075 1.12062 7.78845 0.898825 7.52775 0.751825C7.52425 0.749825 7.52075 0.747826 7.51715 0.745726C7.42635 0.693626 7.32785 0.656125 7.22775 0.625825C7.22375 0.624625 7.21965 0.623426 7.21545 0.622126C6.80575 0.498926 6.30975 0.568425 5.96175 0.823825ZM6.93915 4.04282C6.88265 4.04702 6.82625 4.04653 6.76955 4.04623C6.75865 4.04623 6.74775 4.04623 6.73685 4.04613C6.71055 4.04613 6.68415 4.04603 6.65775 4.04583C6.65695 4.51133 6.65625 4.97673 6.65575 5.44213C6.65575 5.44903 6.65575 5.45593 6.65575 5.46303C6.65555 5.61273 6.65545 5.76242 6.65535 5.91212C6.65525 5.98552 6.65525 6.05903 6.65515 6.13243C6.65515 6.13973 6.65515 6.14703 6.65515 6.15453C6.65495 6.39133 6.65455 6.62813 6.65415 6.86493C6.65365 7.10823 6.65335 7.35162 6.65325 7.59492C6.65325 7.62932 6.65325 7.66373 6.65325 7.69813C6.65325 7.70483 6.65325 7.71163 6.65325 7.71863C6.65315 7.82743 6.65295 7.93633 6.65265 8.04523C6.65235 8.15473 6.65225 8.26422 6.65235 8.37362C6.65235 8.43872 6.65225 8.50373 6.65195 8.56873C6.65185 8.61223 6.65185 8.65572 6.65195 8.69922C6.65205 8.72392 6.65205 8.74873 6.65185 8.77343C6.65005 8.91253 6.65005 8.91252 6.70575 9.03782C6.71335 9.05212 6.72015 9.06663 6.72695 9.08133C6.73035 9.08823 6.73365 9.09522 6.73715 9.10242C6.74225 9.11292 6.74225 9.11293 6.74745 9.12373C6.75105 9.13123 6.75465 9.13883 6.75835 9.14633C6.77465 9.18023 6.79095 9.21412 6.80675 9.24822C6.80925 9.25352 6.81175 9.25893 6.81435 9.26443C6.81885 9.27413 6.82335 9.28392 6.82785 9.29362C6.83715 9.31682 6.83715 9.31683 6.85575 9.33183C6.87035 9.30053 6.88485 9.26923 6.89935 9.23783C6.90425 9.22723 6.90915 9.21663 6.91405 9.20603C6.92115 9.19053 6.92835 9.17503 6.93545 9.15963C6.93755 9.15503 6.93975 9.15052 6.94185 9.14582C6.94635 9.13612 6.95075 9.12632 6.95495 9.11662C6.96375 9.09782 6.96375 9.09783 6.97555 9.07803C7.02405 8.99193 7.01845 8.89932 7.01765 8.80372C7.01745 8.77832 7.01765 8.75282 7.01765 8.72742C7.01775 8.68292 7.01775 8.63842 7.01755 8.59402C7.01725 8.52782 7.01725 8.46172 7.01725 8.39552C7.01735 8.28432 7.01715 8.17303 7.01685 8.06173C7.01655 7.95163 7.01645 7.84143 7.01635 7.73133C7.01635 7.72443 7.01635 7.71763 7.01635 7.71053C7.01635 7.67573 7.01635 7.64092 7.01625 7.60612C7.01615 7.35972 7.01585 7.11323 7.01545 6.86683C7.01495 6.62753 7.01465 6.38812 7.01445 6.14882C7.01445 6.14142 7.01445 6.13402 7.01445 6.12642C7.01435 6.05232 7.01425 5.97823 7.01425 5.90403C7.01415 5.75303 7.01395 5.60203 7.01385 5.45103C7.01385 5.44413 7.01385 5.43713 7.01385 5.43003C7.01335 4.96663 7.01265 4.50323 7.01175 4.03983C6.98735 4.03973 6.96355 4.04072 6.93915 4.04282Z';
                    const otherSvgPath3 =
                        'M7.02394 0.771672C7.07604 0.819472 7.10834 0.871971 7.11454 0.943371C7.11714 1.01437 7.10154 1.07447 7.05434 1.12847C7.00964 1.17337 6.96514 1.19957 6.90254 1.21057C6.89664 1.21167 6.89664 1.21167 6.89064 1.21277C6.88224 1.21427 6.87394 1.21567 6.86564 1.21717C6.84394 1.22097 6.82224 1.22497 6.80064 1.22897C6.79644 1.22977 6.79224 1.23057 6.78784 1.23137C6.66434 1.25407 6.55164 1.29207 6.44104 1.35177C6.43554 1.35477 6.43014 1.35767 6.42444 1.36077C6.32614 1.41687 6.24884 1.49457 6.18304 1.58577C6.17934 1.59087 6.17564 1.59597 6.17184 1.60117C6.07584 1.74237 6.03594 1.91897 6.01164 2.08527C5.99994 2.16367 5.97774 2.22707 5.91344 2.27767C5.85414 2.31887 5.79374 2.33917 5.72154 2.32677C5.68124 2.31777 5.64754 2.30437 5.61304 2.28177C5.60784 2.27847 5.60264 2.27507 5.59724 2.27167C5.54324 2.21907 5.51504 2.15717 5.51364 2.08187C5.51674 1.73667 5.67664 1.36747 5.91904 1.12377C5.92214 1.12057 5.92534 1.11747 5.92864 1.11417C6.00564 1.03757 6.09444 0.973071 6.18904 0.919771C6.19344 0.917271 6.19774 0.914771 6.20234 0.912271C6.38934 0.807171 6.82764 0.611572 7.02394 0.771672Z';
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, otherSvgPath1, true) +
                            getPOISVGPath(color, otherSvgPath2, true) +
                            getPOISVGPath(color, otherSvgPath3, true),
                    );
                    mapIcon = 'other.png';
                    break;
                case 'featured':
                    const featuredSvgPath1 =
                        'M7.5 0.75C7.82886 0.75 8.11964 0.964152 8.2168 1.27832L9.46973 5.33398H13.5C13.8216 5.33398 14.1079 5.53911 14.2109 5.84375C14.3137 6.14824 14.2105 6.48458 13.9551 6.67969L10.6631 9.19434L11.9248 13.2783C12.0211 13.5899 11.9051 13.9286 11.6377 14.1152C11.3701 14.3019 11.0122 14.2938 10.7529 14.0957L7.5 11.6104L4.24707 14.0957C3.98782 14.2938 3.62988 14.3019 3.3623 14.1152C3.09489 13.9286 2.9789 13.5899 3.0752 13.2783L4.33594 9.19434L1.04492 6.67969C0.789521 6.48458 0.686337 6.14824 0.789062 5.84375C0.892112 5.53911 1.1784 5.33398 1.5 5.33398H5.53027L6.7832 1.27832L6.82812 1.16602C6.95319 0.914184 7.212 0.75 7.5 0.75Z';
                    width = 12;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, featuredSvgPath1, false, true, 1.5),
                    );
                    mapIcon = 'featured.png';
                    break;
                default:
                    width = 13;
                    SVGElement = getPOISVGElement(
                        width,
                        height,
                        getPOISVGPath(color, GENERIC_MARKER_ICON_PATH, true) +
                            getPOISVGPath(color, GENERIC_MARKER_ICON_PATH2, true),
                    );
                    mapIcon = GENERIC_MARKER_MAP_ICON;
                    break;
            }
        } else {
            width = 13;
            SVGElement = getPOISVGElement(
                width,
                height,
                getPOISVGPath(color, GENERIC_MARKER_ICON_PATH, true) +
                    getPOISVGPath(color, GENERIC_MARKER_ICON_PATH2, true),
            );
            mapIcon = GENERIC_MARKER_MAP_ICON;
        }

        if (!onlySVG) {
            return {
                anchor: anchor,
                url:
                    '/assets/images/map/markers/points-of-interest-icons/' +
                    (isHover ? 'hover/' : isSelected ? 'selected/' : '') +
                    mapIcon,
                size: mapIcon === GENERIC_MARKER_MAP_ICON ? GENERIC_MARKER_SIZE : LOCATION_MARKER_SIZE,
                scaledSize: mapIcon === GENERIC_MARKER_MAP_ICON ? GENERIC_MARKER_SIZE : LOCATION_MARKER_SIZE,
            };
        }

        if (size != null) {
            const SVG_WIDTH_REGEX = /width="(\d+)"/;
            const SVG_HEIGHT_REGEX = /height="(\d+)"/;

            const svgWidth = SVGElement.match(SVG_WIDTH_REGEX);
            const svgHeight = SVGElement.match(SVG_HEIGHT_REGEX);

            if (svgWidth && svgHeight) {
                if (parseInt(svgWidth[1]) > parseInt(svgHeight[1])) {
                    SVGElement = SVGElement.replace(SVG_WIDTH_REGEX, 'width="' + size + '"').replace(
                        SVG_HEIGHT_REGEX,
                        '',
                    );
                } else {
                    SVGElement = SVGElement.replace(SVG_WIDTH_REGEX, '').replace(
                        SVG_HEIGHT_REGEX,
                        'height="' + size + '"',
                    );
                }
            }
        }

        return SVGElement;
    }

    function getPOISVGElement(width, height, SVGPaths) {
        return `<svg width="${width}" height="${height}" class="place-svg" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg" focusable="false">${SVGPaths}</svg>`;
    }

    function getPOISVGPath(color, SVGPath, fillRule = false, useStrokeInsteadOfFill = false, strokeWidth = null) {
        const className = useStrokeInsteadOfFill
            ? color
                ? 'stroke-primary'
                : 'stroke-white'
            : color
              ? 'fill-primary'
              : 'fill-white';
        const fillRuleAttr = fillRule ? ' fill-rule="evenodd" clip-rule="evenodd"' : '';
        const fillStrokeAttr = useStrokeInsteadOfFill
            ? ` fill="none" ${color ? `stroke="${color}"` : 'stroke="#ffffff"'}`
            : color
              ? `fill="${color}"`
              : 'fill="#ffffff"';
        const strokeWidthAttr = strokeWidth ? ` stroke-width="${strokeWidth}"` : '';

        return `<path class="place-svg-path ${className} " d="${SVGPath}" ${fillRuleAttr}${fillStrokeAttr}${strokeWidthAttr}></path>`;
    }

    /**
     * Will synch infobox with active results list items.  If there is a match in the results list, will activate results item.  If no match, then close the popup infobox
     **/
    function processInfoBox() {
        setTimeout(function () {
            // need this timer to allow immediately subsequent map queries and retries to complete first
            var infoWindowStatus = $('.info-bubble-container').parent().css('display');
            if (typeof infoWindowStatus !== 'undefined') {
                if ($('.info-bubble-container').parent().css('display') === 'block') {
                    var infoBubblepoiId = $('.info-bubble').attr('data-poiId');
                    var $matchedResultsListingElement = $(
                        '.communityMap .map-results-listing #' + infoBubblepoiId + ':first',
                    );
                    if ($matchedResultsListingElement.length > 0) {
                        // if there is a match in the results list, make sure it is active
                        if (!$matchedResultsListingElement.hasClass('active')) {
                            $matchedResultsListingElement.addClass('active');
                        }
                    } else {
                        // if no match, then close the popup infobox
                        infowindow.close();
                    }
                }
            }
        }, 600);
    }

    /**
     * Will remove the given markers from the map so that they are no longer displayed.
     *            Cannot assume we need to close the popup infobox since: 1) we may redisplay this marker with an immediately following map query or this popup is still be displayed due to another item in the results list that is the same POIId and is active
     **/
    function removeMarkers(markers) {
        var marker;

        for (var i = 0; i < markers.length; i++) {
            marker = markers[i];
            marker.setMap(null);
            google.maps.event.trigger(marker, 'marker-removed', {});
        }
    }

    /**
     * Removes all point of interest markers from the map and array.
     **/
    function removePOIMarkers() {
        removeMarkers(poiMarkers);
        poiResultsMap = {};
        poiMarkers = [];
    }

    /**
     * Removes all keyword markers from the map and array.
     **/
    function removeKeywordMarkers() {
        removeMarkers(keywordMarkers);
        keywordMarkers = [];
        $mapResultsListing.find('.place-type.keyword-search').remove();
        $mapResultsListing.find('.place.keyword-search.no-keyword-results').remove();
    }

    /**
     * Clears entire search including: selected pois, keyword typed in, and all markers on the map. Will even reset the view to be where it started.
     **/
    function clearSearch() {
        $noResults.addClass('shown');
        $mapResults.addClass('closed');
        $mapResultsWrapper.removeClass('results-opened');
        $mapResultsDisplayStatus.text(RESULTS_DISPLAY_CLOSED);

        if (!!$featuredPois) {
            $featuredPois.removeClass('active');
        }

        removePOIMarkers();
        removeKeywordMarkers();

        $poiSelect.find('.poi-choice input[type="checkbox"]').prop('checked', false);
        $keywordSearch.val('');

        gMap.setCenter(new google.maps.LatLng(lat, lng));
        gMap.setZoom(INITIAL_ZOOM_LEVEL);
    }

    function showKeywordResults(results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            for (var i = 0, place; (place = results[i]); i++) {
                var keywordMarker = createMarker(place, null, true, KEYWORD_SEARCH_POI_ID);
                keywordMarkers.push(keywordMarker);
                placesIdMap[KEYWORD_SEARCH_POI_ID].push(keywordMarker);
            }

            var $listPlaceTypeHeader = $(
                '<li class="place-type keyword-search" tabindex="0"><span class="name" title="' +
                    $keywordSearch.val() +
                    '">Search: ' +
                    $keywordSearch.val() +
                    '</span></li>',
            );
            attachListingKeyHandler($listPlaceTypeHeader);
            $mapResultsListing.prepend($listPlaceTypeHeader);
            $mapResults.removeClass('closed');
            $mapResultsWrapper.addClass('results-opened');
            $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
            $noResults.removeClass('shown');
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            if (!poiMarkers.length) {
                $noResults.addClass('shown');
            } else {
                $mapResultsListing.prepend(
                    $('<li class="place keyword-search no-keyword-results">No search results found.</li>'),
                );
                $mapResultsListing.prepend(
                    $(
                        '<li class="place-type keyword-search"><span class="name" title="' +
                            $keywordSearch.val() +
                            '">Search: ' +
                            $keywordSearch.val() +
                            '</span></li>',
                    ),
                );
            }
        }
    }

    /**
     * Shows the keyword search's results on the map.
     **/
    function getKeywordResults(keyword) {
        removeKeywordMarkers();
        placesIdMap[KEYWORD_SEARCH_POI_ID] = [];

        if (!!keyword) {
            runNearBySearch(keyword, null, true, showKeywordResults);
            $noResults.text(NO_RESULTS_FOUND);
        } else if ($poiSelect.find('.poi-choice:not(.poi-group-choice) input[type="checkbox"]:checked').length === 0) {
            $noResults.text(NO_RESULTS_NO_SEARCH_SELECTED);
        }
    }

    /**
     * Show map marker information in the infowindow.
     **/
    function showMapMarkerInfo(marker, infowindowContent) {
        if (isMobile) {
            selectedMarkerInfoBoxMobile.innerHTML = infowindowContent;
        } else {
            infowindow.setContent(infowindowContent);
            infowindow.open(gMap, marker);
        }
    }

    /**
     * Scrolls given list item into view and adds necessary class name.
     **/
    function scrollItemToTop($this) {
        var top = $this.position();
        $mapResultsListing.find('li.place.active').removeClass('active');

        setTimeout(function () {
            $this.addClass('active');
            $('.info-bubble').attr('data-poiId', $this.attr('id'));
        }, 50);
        $mapResults.scrollTop(top.top);
    }

    /**
     * Add's a focus handler to the marker's list item so that it can popup the marker's info.
     **/
    function attachListingClickEvent($listItem, marker) {
        $listItem.on('click', function () {
            if ($listItem.hasClass('active')) {
                trackEvent(GA_EVENT_CATEGORY, 'poi-result-closed', GA_GENERIC_EVENT_LABEL);
                infowindow.close();
                google.maps.event.trigger(marker, 'hide-marker-info', {});
            } else {
                trackEvent(GA_EVENT_CATEGORY, 'poi-result-opened', GA_GENERIC_EVENT_LABEL);
                google.maps.event.trigger(marker, 'display-marker-info', {});
                setTimeout(function () {
                    $('.info-bubble').attr('data-poiId', $listItem.attr('id'));
                }, 100);
            }
        });
    }

    /**
     * Add's a key handler to the marker's list item so that a keyboard user can navigate up and down the results list.
     **/
    function attachListingKeyHandler($listItem) {
        $listItem.on('keydown', function (evt, poiId) {
            switch (evt.which) {
                case 40: // check for  down arrow (40)
                    $(this).next().focus().click(); // go to next item in list
                    evt.preventDefault();
                    break;

                case 38: // check for up arrow (38)
                    $(this).prev().focus().click(); // go to previous item in list
                    evt.preventDefault();
                    break;

                case 36: // check for home key (36)
                    $('.map-results-listing .place:first').focus().click(); // go to top of list
                    evt.preventDefault();
                    break;

                case 35: // check for end key (35)
                    $('.map-results-listing .place:last').focus().click(); // go to end of list
                    evt.preventDefault();
                    break;
            }
        });
    }

    function getPlaceLatLng(place) {
        return {
            latitude:
                typeof place.geometry.location.lat === 'function'
                    ? place.geometry.location.lat()
                    : place.geometry.location.lat,
            longitude:
                typeof place.geometry.location.lng === 'function'
                    ? place.geometry.location.lng()
                    : place.geometry.location.lng,
        };
    }

    /**
     * Adds the marker's info to the listing
     **/
    function addMarkerToListing(place, marker, icon, poiId, typeName) {
        var content =
            '<li class="active-background-primary place ' +
            poiId +
            '" id="' +
            place.place_id +
            '" tabindex="-1">' +
            (isMobile ? '' : '<div class="place-arrow"></div>') +
            '<div class="place-icon">' +
            getPOIIcon(typeName, null, true) +
            '</div><div class="place-info-wrapper"><span class="place-name">' +
            place.name +
            '</span>';

        if (place.vicinity) {
            content = content + '<span class="place-address">' + place.vicinity + '</span>';
        } else {
            content = content + '<span class="place-address">' + place.formatted_address + '</span>';
        }

        const placeLatLng = getPlaceLatLng(place);

        var distanceRounded1Decimal = (
            Math.round(distanceCalc(placeLatLng.latitude, lat, placeLatLng.longitude, lng) * 10) / 10
        ).toString();
        content =
            content +
            '<span class="place-distance">' +
            distanceRounded1Decimal +
            (distanceRounded1Decimal === '1' ? ' mile' : ' miles') +
            '</span></div></li>'; // add distance to listing

        var $listItem;

        if ($mapResultsListing.find('.place.' + poiId).length) {
            $listItem = $(content);
            $mapResultsListing.find('.place.' + poiId + ':first').before($listItem);
        } else {
            $listItem = $(content).prependTo($mapResultsListing);
        }

        attachListingClickEvent($listItem, marker);
        attachListingKeyHandler($listItem);
        safeStickyFooter();

        return $listItem;
    }

    /**
     * Show map marker info
     **/
    function displayMarkerInfo(marker, infowindowContent, typeName) {
        selectMarker(marker, typeName);
        if (selectedMarker.marker != null) {
            showMapMarkerInfo(marker, infowindowContent);
        }

        if (!isMobile) {
            var intervalCount = 0,
                closeBtnInterval = setInterval(function () {
                    var $infoWindowCloseBtn = $communityMap.find('.info-bubble .btn.close-btn');

                    if ($infoWindowCloseBtn.length) {
                        $infoWindowCloseBtn.on('click', function () {
                            google.maps.event.trigger(marker, 'hide-marker-info', {});
                        });

                        clearInterval(closeBtnInterval);
                    }

                    //Let's not do this forever
                    if (intervalCount > 50) {
                        clearInterval(closeBtnInterval);
                    }

                    intervalCount++;
                }, 20);
        }
    }

    function selectMarker(marker, typeName) {
        // If we already have a marker selected, set its icon back to its normal state
        if (selectedMarker && selectedMarker.marker) {
            selectedMarker.marker.setIcon(
                getPOIIcon(selectedMarker.typeName, mapPrimaryColor, false, null, false, false),
            );
        }
        if (selectedMarker.marker !== marker) {
            // Set new selected marker's icon to its selected state and set selectedMarker
            if (typeName) {
                marker.setIcon(getPOIIcon(typeName, mapPrimaryColor, false, null, false, true));
            }
            selectedMarker = { marker: marker, typeName: typeName };
        } else {
            // Unselect marker if already selected marker is selected again.
            google.maps.event.trigger(marker, 'hide-marker-info', {});
        }
    }

    /**
     * Will create a marker with the given svg icon construction, when icon is null it'll create the default one using the primary color.
     **/
    function createMarker(place, icon, addToListing, poiId, typeName) {
        var placeLoc = place.geometry.location,
            markerIcon = getPOIIcon(null, mapPrimaryColor, false);

        //We assume that these are icons
        if (icon != null) {
            markerIcon = icon;
        }

        //Setup default value
        if (addToListing == null) {
            addToListing = true;
        }

        var marker = new google.maps.Marker({
            map: gMap,
            icon: markerIcon,
            position: placeLoc,
            draggable: false,
            title: place.name,
            zIndex: 1,
            optimized: false,
        });

        const mobileInfoIcon = getPOIIcon(typeName, null, true, 24);

        var infowindowContent =
            (isMobile ? mobileInfoIcon : '<button class="btn close-btn color-primary">x</button>') +
            '<div class="place-info" data-poiId="' +
            poiId +
            '">';

        if (place.vicinity) {
            infowindowContent +=
                '<p class="place-name">' + place.name + '</p><p class="place-address">' + place.vicinity + '</p>';
        } else {
            infowindowContent +=
                '<p class="place-name">' +
                place.name +
                '</p><p class="place-address">' +
                place.formatted_address +
                '</p>';
        }

        if (addToListing) {
            const placeLatLng = getPlaceLatLng(place);

            var distanceRounded1Decimal = (
                Math.round(distanceCalc(placeLatLng.latitude, lat, placeLatLng.longitude, lng) * 10) / 10
            ).toString();
            infowindowContent =
                infowindowContent +
                '<p class="place-distance">' +
                distanceRounded1Decimal +
                (distanceRounded1Decimal === '1' ? ' mile' : ' miles') +
                '</p></div>'; // add distance to popup info
        } else {
            infowindowContent = infowindowContent + '</div>';
        }

        google.maps.event.addListener(marker, 'click', function () {
            trackEvent(GA_EVENT_CATEGORY, 'poi-marker-clicked', GA_GENERIC_EVENT_LABEL);
            displayMarkerInfo(marker, infowindowContent, typeName);
        });

        if (typeName) {
            marker.addListener('mouseover', function () {
                if (selectedMarker.marker !== marker) {
                    marker.setIcon(getPOIIcon(typeName, mapPrimaryColor, false, null, true));
                }
            });

            marker.addListener('mouseout', function () {
                if (selectedMarker.marker !== marker) {
                    marker.setIcon(getPOIIcon(typeName, mapPrimaryColor, false, null, false));
                }
            });
        }

        if (addToListing) {
            var $listItem = addMarkerToListing(place, marker, markerIcon, poiId, typeName);

            google.maps.event.addListener(marker, 'marker-removed', function () {
                if (poiId) {
                    $listItem.siblings('.place-type.' + poiId).remove();
                }
                var placeId = $listItem.prop('id');

                delete placesIdMap[poiId][placeId];
                const poiMarkersIndex = poiMarkers.indexOf(marker);
                if (poiMarkersIndex > -1) {
                    poiMarkers.splice(poiMarkersIndex, 1);
                }

                $listItem.remove();
                safeStickyFooter();
            });

            google.maps.event.addListener(marker, 'marker-shown', function () {
                attachListingClickEvent($listItem, marker);
                safeStickyFooter();
            });

            google.maps.event.addListener(marker, 'click', function () {
                if (selectedMarker.marker != null) {
                    scrollItemToTop($listItem);
                }
            });

            google.maps.event.addListener(marker, 'display-marker-info', function () {
                displayMarkerInfo(marker, infowindowContent, typeName);

                $mapResultsListing.find('li.place.active').removeClass('active');
                $listItem.addClass('active');
                $('.info-bubble').attr('data-poiId', $listItem.attr('id'));
                const markerPosition = marker.getPosition();
                if (isMobile && markerPosition) {
                    gMap.panTo(markerPosition);
                }
            });
        }

        google.maps.event.addListener(marker, 'hide-marker-info', function () {
            infowindow.close();
            marker.setIcon(getPOIIcon(typeName, mapPrimaryColor, false, null, false, false));
            selectedMarker = { marker: null, typeName: null };

            if (isMobile && selectedMarkerInfoBoxMobile) {
                selectedMarkerInfoBoxMobile.innerHTML = '';
            }

            if (addToListing) {
                $mapResultsListing.find('li.place.active').removeClass('active');
            }
        });

        return marker;
    }

    /**
     * Process the google places response that's been forwarded from the webservice.
     **/
    function processPlacesResponse(poiId, keyword, results, status, icon, typeName) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            if (results.length) {
                var placesToKeep = [];
                poiResultsMap[poiId] = { markers: [] };
                if (!placesIdMap[poiId]) {
                    placesIdMap[poiId] = {};
                }

                for (var i = 0; i < results.length; i++) {
                    var result = results[i],
                        placeId = result.place_id,
                        types = result.types,
                        isRealBeach;
                    // Beach Place type from googlemaps is not reliable. Use text search and filter response
                    keyword == 'beach' && (types.indexOf('park') > -1 || types.indexOf('natural_feature') > -1)
                        ? (isRealBeach = true)
                        : (isRealBeach = false);

                    if (keyword != 'beach' || isRealBeach) {
                        if (!placesIdMap[poiId][placeId]) {
                            placesIdMap[poiId][placeId] = createMarker(result, icon, true, poiId, typeName);
                        }
                        poiResultsMap[poiId].markers.push(placesIdMap[poiId][placeId]);
                        poiMarkers.push(placesIdMap[poiId][placeId]);
                        placesToKeep.push(placeId);
                    }
                }

                var placeIdsArr = Object.keys(placesIdMap[poiId]),
                    placesMap = placesIdMap[poiId];

                for (var i = 0; i < placeIdsArr.length; i++) {
                    var placeId = placeIdsArr[i];
                    if (placesToKeep.indexOf(placeId) < 0) {
                        removeMarkers([placesMap[placeId]]);
                        delete placesMap[placeId];
                    }
                }

                if ($mapResultsListing.find('.place-type.' + poiId).length) {
                    $mapResultsListing.find('.place-type.' + poiId).remove();
                }
                var $listPlaceTypeHeader = $(
                    '<li id="place-type-' +
                        poiId +
                        '" class="place-type ' +
                        poiId +
                        '" tabindex="0"><span class="name">' +
                        typeName +
                        '</span><span class="listing-border"></span></li>',
                );
                attachListingKeyHandler($listPlaceTypeHeader);
                $mapResultsListing.find('.place.' + poiId + ':first').before($listPlaceTypeHeader);
            } else {
                $mapResultsListing.find('.place-type.' + poiId).remove();
                if (poiResultsMap[poiId] != null) {
                    removeMarkers(poiResultsMap[poiId].markers);
                }
                delete poiResultsMap[poiId];
            }
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            $mapResultsListing.find('.place-type.' + poiId).remove();

            if (poiResultsMap[poiId] != null) {
                removeMarkers(poiResultsMap[poiId].markers);
            }
            delete poiResultsMap[poiId];
        }

        //We are lazy, so let's just check each time
        if (poiMarkers.length > 0 || keywordMarkers.length > 0) {
            if (!isMobile) {
                $mapResults.removeClass('closed');
                $mapResultsWrapper.addClass('results-opened');
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
            }
            $noResults.removeClass('shown');
        } else {
            if (!isMobile) {
                $mapResults.removeClass('closed');
                $mapResultsWrapper.addClass('results-opened');
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
            }
            $noResults.addClass('shown');
        }
        processInfoBox(); // determine if we need to close the popup info box or activate an item in the updated results list
    }

    /**
     * Processes the places queue and will try to load that places info once more.
     **/
    function processRetryQueue() {
        if (placesRetryQueue.length > 0) {
            setTimeout(function () {
                var placeInfo = placesRetryQueue.shift();
                runNearBySearch(placeInfo.keyword, placeInfo.type, false, placeInfo.successCallback);
                processRetryQueue();
            }, 500);
        }
    }

    /**
     * Runs the near by search with google's api.
     */
    function runNearBySearch(keyword, type, tryAgain, successCallback) {
        var request = {
            bounds: gMap.getBounds(),
            keyword: keyword,
        };

        if (!!type) {
            request.type = type;
        }

        var service = new google.maps.places.PlacesService(gMap);
        service.nearbySearch(request, function (results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT && tryAgain) {
                placesRetryQueue.push({
                    keyword: keyword,
                    type: type,
                    successCallback: successCallback,
                });
            } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
                console.error('Over google places service query limit.');
            } else {
                successCallback(results, status);
            }
        });
    }

    /**
     * Loads places given the keyword and type using our google places forwarding api. Icon is passed along in marker creation.
     **/
    function loadPlaces(poiId, keyword, type, displayText, icon, tryAgain) {
        runNearBySearch(keyword, type, tryAgain, function (results, status) {
            processPlacesResponse(poiId, keyword, results, status, icon, displayText);
        });
    }

    /**
     * Updates the points of interest being shown. Is throttled so that if someone selects a bunch of choices quickly, we don't end up doing requests we won't use or something.
     **/
    function updatePOIsShown(updateExistingResults, showNoResults) {
        initSearchableMap();
        if (!updateExistingResults) {
            updateExistingResults = false;
        }

        clearTimeout(poiUpdateThrottle);

        const $selectedPOIs = $poiSelect.find('.poi-choice:not(.poi-group-choice) input[type="checkbox"]:checked');
        if ($selectedPOIs.length > 0) {
            const placesOfInterestLabel = $selectedPOIs
                .siblings('label')
                .map(function () {
                    return $(this).text();
                })
                .get()
                .join(', ');

            poiDisplayLabel.textContent = placesOfInterestLabel;
            $noResults.text(NO_RESULTS_FOUND);
        } else if (!$keywordSearch.val()) {
            poiDisplayLabel.textContent = 'Places of interest';
            $noResults.text(NO_RESULTS_NO_SEARCH_SELECTED);
        }

        poiUpdateThrottle = setTimeout(function () {
            //Let's remove only non-selected markers
            var $notSelectedPOIs = $poiSelect.find(
                '.poi-choice:not(.poi-group-choice) input[type="checkbox"]:not(:checked)',
            );
            if ($notSelectedPOIs.length > 0) {
                $notSelectedPOIs.each(function () {
                    var $this = $(this),
                        poiId = $this.prop('id');

                    if (!!poiResultsMap[poiId]) {
                        removeMarkers(poiResultsMap[poiId].markers);
                        delete poiResultsMap[poiId];
                    }
                });
            }

            //Now let's show selected markers that aren't already shown
            var $selectedPOIs = $poiSelect.find('.poi-choice:not(.poi-group-choice) input[type="checkbox"]:checked');
            if ($selectedPOIs.length) {
                poiMarkers = [];

                $selectedPOIs.each(function () {
                    var $this = $(this),
                        poiId = $this.prop('id');

                    if ($this.data('keyword') !== FEATURED_LOCATION_POI.keyword) {
                        //If we have the poi, it's already showing.
                        if (!poiResultsMap[poiId]) {
                            var poiLabel = $this.siblings('label').text();
                            trackEvent(GA_EVENT_CATEGORY, 'poi-selected', poiLabel);

                            loadPlaces(
                                poiId,
                                $this.data('keyword'),
                                $this.data('type'),
                                poiLabel,
                                getPOIIcon(poiLabel, mapPrimaryColor),
                                true,
                            );
                            processRetryQueue();
                        } else if (!!poiResultsMap[poiId] && updateExistingResults) {
                            var poiLabel = $this.siblings('label').text();

                            loadPlaces(
                                poiId,
                                $this.data('keyword'),
                                $this.data('type'),
                                poiLabel,
                                getPOIIcon(poiLabel, mapPrimaryColor),
                                true,
                            );
                            processRetryQueue();
                        }
                    } else if (!poiResultsMap[poiId]) {
                        poiResultsMap[poiId] = { markers: [] };
                        if (!placesIdMap[poiId]) {
                            placesIdMap[poiId] = {};
                        }
                        featuredLocations.forEach((location, index) => {
                            const placeId = FEATURED_LOCATION_POI.keyword + '-' + index;
                            placesIdMap[poiId][placeId] = createMarker(
                                {
                                    place_id: placeId,
                                    name: location.name,
                                    formatted_address: removeStateZipFromAddress(location.fullAddress),
                                    geometry: {
                                        location: {
                                            lat: location.latitude,
                                            lng: location.longitude,
                                        },
                                    },
                                },
                                getPOIIcon(location.categoryDisplayName, mapAccentColor, false),
                                true,
                                poiId,
                                location.categoryDisplayName,
                            );
                            poiMarkers.push(placesIdMap[poiId][placeId]);
                            poiResultsMap[poiId].markers.push(placesIdMap[poiId][placeId]);
                        });

                        if ($mapResultsListing.find('.place-type.' + poiId).length) {
                            $mapResultsListing.find('.place-type.' + poiId).remove();
                        }
                        var $listPlaceTypeHeader = $(
                            '<li id="place-type-' +
                                poiId +
                                '" class="place-type ' +
                                poiId +
                                '" tabindex="0"><span class="name">' +
                                FEATURED_LOCATION_POI.display +
                                '</span><span class="listing-border"></span></li>',
                        );
                        attachListingKeyHandler($listPlaceTypeHeader);
                        $mapResultsListing.find('.place.' + poiId + ':first').before($listPlaceTypeHeader);
                        if (!isMobile) {
                            $mapResults.removeClass('closed');
                            $mapResultsWrapper.addClass('results-opened');
                            $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
                        }
                        $noResults.removeClass('shown');
                    }

                    if (!!poiResultsMap[poiId]) {
                        poiMarkers = poiMarkers.concat(poiResultsMap[poiId].markers);
                    }
                });
            } else if (!keywordMarkers.length && !!showNoResults) {
                //We need to check for empty results and show the no results message if so.
                if (!isMobile) {
                    $mapResults.removeClass('closed');
                    $mapResultsWrapper.addClass('results-opened');
                    $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
                }
                $noResults.addClass('shown');
            }
            processInfoBox(); // determine if we need to close the popup info box or activate an item in the updated results list
        }, POI_UPDATE_TIMEOUT);
    }

    /**
     * Build a generic point of interest choice. We add tabindex so that firefox doesn't lose focus when label is clicked.
     **/
    function buildPOIChoice(keyword, type, color, display, $target) {
        var html =
            '<li class="poi-choice" role="option" ><input id="poi-' +
            poiCount +
            '" type="checkbox" data-keyword="' +
            keyword +
            '" data-type="' +
            type +
            '" tabindex="-1" /><div class="checkbox-indicator"></div><div class="poi-icon">' +
            getPOIIcon(display, color, true) +
            '</div><label for="poi-' +
            poiCount +
            '">' +
            display +
            '</label></li>';
        poiCount++;
        return $(html).appendTo($target);
    }

    /**
     * Build a group point of interest choice. We add tabindex so that firefox doesn't lose focus when label is clicked.
     **/
    function buildGroupPOIChoice(display, color, $target) {
        var html =
            '<li class="poi-choice poi-group-choice" role="option" ><input id="poi-' +
            poiCount +
            '" type="checkbox"  tabindex="-1" /><div class="checkbox-indicator"></div><div class="poi-icon">' +
            getPOIIcon(display, color, true) +
            '</div><label for="poi-' +
            poiCount +
            '">' +
            display +
            '</label></li>';
        poiCount++;
        return $(html).appendTo($target);
    }

    /**
     * Builds out the set of point of interest choices in the ui. Attaches appropriate event handlers and handles the groupings.
     **/
    function buildPOIChoices(choices, $target) {
        $.each(choices, function (idx, newPOI) {
            if (newPOI.isGroup) {
                var $groupPOI = buildGroupPOIChoice(newPOI.display, mapPrimaryColor, $target);

                var subchoices = newPOI.subchoices,
                    $subchoices = $();

                if (subchoices != null && subchoices.length) {
                    var $subchoicesBox = $(
                        '<ul class="poi-subchoices" role="listbox" aria-label="' + newPOI.display + ' subgroup"></ul>',
                    ).insertAfter($groupPOI);

                    $.each(subchoices, function (subIdx, newSubPOI) {
                        var $newSubchoice = buildPOIChoice(
                            newSubPOI.keyword,
                            newSubPOI.type,
                            mapPrimaryColor,
                            newSubPOI.display,
                            $subchoicesBox,
                        );
                        $subchoices = $subchoices.add($newSubchoice);

                        $newSubchoice.on('click', 'input[type="checkbox"]', function () {
                            var $input = $(this),
                                checked = $input.prop('checked');

                            var $groupCheckbox = $groupPOI.find('input[type="checkbox"]'),
                                groupChecked = $groupCheckbox.is(':checked');

                            if (!checked && groupChecked) {
                                $groupCheckbox.prop('checked', false);
                            }

                            if (
                                checked &&
                                !groupChecked &&
                                $subchoices.find('input[type="checkbox"]:checked').length === $subchoices.length
                            ) {
                                $groupCheckbox.prop('checked', true);
                            }

                            updatePOIsShown(false, true);
                        });
                    });
                    $('.poi-choices-box > .poi-subchoices').wrapAll("<li role='option'></li>"); // wrap ul subchoice group with li element to fit correctly in choices-box ul list
                }

                //Group POI Handler
                $groupPOI.on('click', 'input[type="checkbox"]', function () {
                    var $input = $(this),
                        checked = $input.prop('checked');

                    $subchoices.each(function (idx, subchoice) {
                        var $subchoiceInput = $(subchoice).find('input[type="checkbox"]');

                        if ($subchoiceInput.prop('checked') !== checked) {
                            $subchoiceInput.click();
                        }
                    });

                    updatePOIsShown(false, true);
                });
            } else {
                var $newChoice = buildPOIChoice(newPOI.keyword, newPOI.type, mapPrimaryColor, newPOI.display, $target);
                const $checkbox = $newChoice.find('input[type="checkbox"]');

                $newChoice.on('click', 'input[type="checkbox"]', function () {
                    updatePOIsShown(false, true);
                });

                if (newPOI.keyword === FEATURED_LOCATION_POI.keyword) {
                    $checkbox.prop('checked', true);
                }
            }

            $poiSelect.on('keydown', '.poi-choice input', function (evt) {
                switch (evt.which) {
                    case 40: // check for  down arrow (40)
                        $('.poi-choice input#poi-' + (parseInt(this.id.split('-')[1], 10) + 1).toString()).focus(); // go to next input field
                        evt.preventDefault();
                        break;

                    case 38: // check for up arrow (38)
                        $('.poi-choice input#poi-' + (parseInt(this.id.split('-')[1], 10) - 1).toString()).focus(); // go to previous input field
                        evt.preventDefault();
                        break;

                    case 36: // check for home key (36)
                        $('.poi-choice input:first').focus(); // go to top of list
                        evt.preventDefault();
                        break;

                    case 35: // check for end key (35)
                        $('.poi-choice input:last').focus(); // go to end of list
                        evt.preventDefault();
                        break;

                    case 9: // check for tab/shift tab (9)
                        $(this).parents('.poi-select').removeClass('shown'); // collapse drop down
                        break;
                }
            });
        });
    }

    /**
     * Initializes the search ui. Will attach click handlers to buttons, and helps setup the custom dropdown ui for the pois.
     **/
    function initSearch() {
        if (hasFeaturedLocation) {
            mapConfig.unshift(FEATURED_LOCATION_POI);
        }

        var $poiChoicesBox = $poiSelect.find('.poi-choices-box'),
            $submitBtn = $mapSearch.find('.btn.btn-search');

        $resetSearchBtn.on('click', function () {
            trackEvent(GA_EVENT_CATEGORY, 'reset-btn-press', GA_GENERIC_EVENT_LABEL);
            clearSearch();
        });

        function openPOISelection(evt) {
            $('.poi-select').addClass('shown').find('poi-choices-box').css('visibility', 'visible'); // expand the drop down box and restore visibility
            var $firstChoiceChecked = $('.poi-select').find('input:checked:first'); // find the first selected option
            if ($firstChoiceChecked.length === 1) {
                $firstChoiceChecked.focus();
                if ($firstChoiceChecked.parent().parent().hasClass('poi-subchoices')) {
                    // if first selected item is a POI subchoice, set scroll so the POI group containing the selected item appears at the top (both group and subchoice will then be visible)
                    $poiChoicesBox.scrollTop(
                        $firstChoiceChecked.parent().parent().offset().top - // top coordinate of the first checked element we want to end up near top of final scrolled position
                            $poiChoicesBox.offset().top + // top coordinate of top of scroll container.  the difference is their "delta"
                            $poiChoicesBox.scrollTop() - // amount required to fully scroll the container.  We only want to scroll the first checked element to top, so need to subtract the "delta"
                            40,
                    ); // back off (subtract) just a few more pixels (40) from the amount to be scrolled so that we can still see a portion of the preceding element
                } else {
                    $poiChoicesBox.scrollTop(
                        $firstChoiceChecked.offset().top -
                            $poiChoicesBox.offset().top +
                            $poiChoicesBox.scrollTop() -
                            15,
                    ); // scroll amount setting = scroll element to top, but leave some amount short so we see bottom of previous element (hint for user)
                }
            } else {
                $('.poi-choice input:first').focus(); // if there are no selections, then move focus to first item in the POI list of choices
                $poiChoicesBox.scrollTop(0);
            }
        }

        $poiSelect.on('click', '.poi-select-display', function (evt) {
            if ($poiSelect.hasClass('shown')) {
                $poiSelect.removeClass('shown').find('poi-choices-box').css('visibility', 'hidden'); // collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
            } else {
                openPOISelection(evt);
                evt.stopPropagation();
            }
        });

        $poiSelect.on('keypress', '.poi-select-display', function (evt) {
            if (evt.which === 13 || evt.which === 32) {
                // enter or space key toggles poi list display
                openPOISelection(evt);
                evt.preventDefault();
            } else {
                $(this).parents('.poi-select').removeClass('shown').find('poi-choices-box').css('visibility', 'hidden'); // collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
            }
        });

        $poiSelect.on('keydown', '.poi-select-display', function (evt) {
            // down arrow opens up the poi display and moves cursor to item in list
            if (evt.which === 40) {
                openPOISelection(evt);
                evt.preventDefault();
            }
        });

        $poiSelect.on('click', '.poi-choices-box', function (evt) {
            evt.stopPropagation();
        });

        $html.on('click', '*:not(.communityMap .poi-select, .communityMap .poi-select *)', function () {
            $poiSelect.removeClass('shown').find('poi-choices-box').css('visibility', 'hidden'); // collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
        });

        $poiSelect.on('blur', function () {
            $poiSelect.removeClass('shown').find('poi-choices-box').css('visibility', 'hidden'); // collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
        });

        $keywordSearch.on('keydown', function (evt) {
            initSearchableMap();
            if (evt.keyCode === 13) {
                getKeywordResults($keywordSearch.val());
                updatePOIsShown(false, true);
            }
        });

        $keywordSearch.on('focusout', function () {
            initSearchableMap();
            getKeywordResults($keywordSearch.val());
            updatePOIsShown(false, true);
        });

        $submitBtn.on('click', function () {
            trackEvent(GA_EVENT_CATEGORY, 'search-btn-press', GA_GENERIC_EVENT_LABEL);

            initSearchableMap();
            getKeywordResults($keywordSearch.val());
            updatePOIsShown(false, true);
        });

        buildPOIChoices(mapConfig, $poiChoicesBox);
    }

    /**
     * Will initialize the custom map controls for the ui.
     **/
    function initMapControls() {
        var $centerMapBtn = $(
            '<div class="center-map-btn"><img class="center-icon" src="/assets/images/map/target.png" alt="Re-Center Icon" /></div>',
        );
        $centerMapBtn.on('click', function (evt, track) {
            if (!track || track) {
                trackEvent(GA_EVENT_CATEGORY, 'center-btn-press', GA_GENERIC_EVENT_LABEL);
            }
            gMap.setCenter({ lat: lat, lng: lng });
        });

        gMap.controls[google.maps.ControlPosition.BOTTOM_CENTER].push($centerMapBtn.get(0));
    }

    /**
     * Updates map results for both places of interest and keyword search
     **/
    function updateMapResults() {
        clearTimeout(mapViewChangeThrottle);
        mapViewChangeThrottle = setTimeout(function () {
            getKeywordResults($keywordSearch.val());
            updatePOIsShown(true, false);
        }, MAP_VIEW_CHANGE_THROTTLE_TIME);
    }

    /**
     * Initializes the results tab, allowing it to be shown or hidden.
     */
    function initResultsTab() {
        var $resultsToggle = $mapResults.find('.map-results-toggle');

        $resultsToggle.on('click', function (evt) {
            $mapResults.toggleClass('closed');
            $mapResultsWrapper.toggleClass('results-opened');
            if ($mapResultsWrapper.hasClass('results-opened')) {
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
                $('.place-type').attr('tabindex', '0');
            } else {
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_CLOSED);
                $('.place-type').attr('tabindex', '-1');
            }
            evt.preventDefault();
        });

        $noResults.addClass('shown');
    }

    function buildFeaturedPOI(featuredPOI) {
        var poiSVG = getPOIIcon(featuredPOI.display, mapPrimaryColor, true);
        return (
            '<div class="featured-place active-background-primary background-transparent" tabindex="0" role="button" aria-pressed="false"><div class="place-icon">' +
            poiSVG +
            '</div><div class="place-name">' +
            featuredPOI.display +
            '</div></div>'
        );
    }

    function initFeaturedPOIS() {
        if (hasFeaturedLocation) {
            featuredPOIs.unshift(FEATURED_LOCATION_POI);
        }

        if (featuredPOIs.length) {
            var $featuredPOIContainer = $('.communityMap .map-featured-places .featured-places-list'),
                $selectPOIs = $poiSelect.find('.poi-choice input[type="checkbox"]');

            featuredPOIs.forEach(function (featuredPOI) {
                var featuredPOIHTML = buildFeaturedPOI(featuredPOI),
                    $featuredPOI = $(featuredPOIHTML).appendTo($featuredPOIContainer),
                    $associatedPOI = $selectPOIs.filter(function () {
                        return $(this).data('keyword') === featuredPOI.keyword;
                    }),
                    ignoreAssociatedClick = false;

                $featuredPOI.on('click', function (evt) {
                    $featuredPOI.toggleClass('active');
                    $featuredPOI.attr('aria-pressed', $featuredPOI.attr('aria-pressed') !== 'true');
                    ignoreAssociatedClick = true;
                    $associatedPOI.click();
                    if (!$featuredPOI.hasClass('active')) {
                        // if we just toggled this POI to inactive, then determine if we need to close the popup info box or activate another item in the results list
                        processInfoBox();
                    }
                });

                $featuredPOI.on('keydown keypress', function (evt) {
                    if (evt.which === 13 || evt.which === 32) {
                        // check for enter or space key pressed
                        $featuredPOI.click();
                        evt.preventDefault();
                    }
                });

                $associatedPOI.on('click', function () {
                    if (!ignoreAssociatedClick) {
                        $featuredPOI.toggleClass('active');
                        $featuredPOI.attr('aria-pressed', $featuredPOI.attr('aria-pressed') !== 'true');
                        if (!$featuredPOI.hasClass('active')) {
                            // if we just toggled this POI to inactive, then determine if we need to close the popup info box or activate another item in the results list
                            processInfoBox();
                        }
                    } else {
                        ignoreAssociatedClick = false;
                    }
                });

                if (featuredPOI.keyword === FEATURED_LOCATION_POI.keyword) {
                    $featuredPOI.addClass('active');
                    $featuredPOI.attr('aria-pressed', true);
                }
            });
            return $featuredPOIContainer.find('.featured-place');
        }
    }

    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16),
              }
            : null;
    }

    function convertColorsToRGB() {
        if (mapAccentColor.indexOf('#') >= 0) {
            var accentRGB = hexToRgb(mapAccentColor);
            if (accentRGB !== null) {
                mapAccentColor = 'rgb(' + accentRGB.r + ',' + accentRGB.g + ',' + accentRGB.b + ')';
            }
        }

        if (mapPrimaryColor.indexOf('#') >= 0) {
            var primaryRGB = hexToRgb(mapPrimaryColor);
            if (accentRGB !== null) {
                mapPrimaryColor = 'rgb(' + primaryRGB.r + ',' + primaryRGB.g + ',' + primaryRGB.b + ')';
            }
        }
    }

    /**
     * Initializes everything from the map to the search ui and fills some variables we need later on. Should only get ran once.
     **/
    function initSearchableMap() {
        if (initializedSearchable) {
            return;
        }

        initializedSearchable = true;

        var mapOptions = {
            center: new google.maps.LatLng(lat, lng),
            zoom: INITIAL_ZOOM_LEVEL,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: !isMobile,
        };

        //This will help ensure that we don't accidentally lose any event listeners
        document.getElementById('communityMap').innerHTML = '';
        gMap = new google.maps.Map(document.getElementById('communityMap'), mapOptions);
        google.maps.event.addListener(gMap, 'zoom_changed', updateMapResults);
        google.maps.event.addListener(gMap, 'dragend', updateMapResults);
        google.maps.event.addListener(gMap, 'resize', updateMapResults);

        communityMarker = createMarker(
            {
                geometry: {
                    location: {
                        lat: lat,
                        lng: lng,
                    },
                },
                name: $communityMap.data('community-name'),
                formatted_address: $communityMap.data('formatted-address'),
            },
            getPOIIcon(null, mapAccentColor, false),
            false,
            -1,
            null,
        );

        google.maps.event.addListener(communityMarker, 'click', function () {
            $mapResultsListing.find('li.place.active').removeClass('active');
        });

        infowindow = new InfoBubble(DEFAULT_INFO_BUBBLE_OPTIONS);
        infowindow.setMaxHeight(45);

        initMapControls();
    }

    function init() {
        if (initialized) {
            return;
        }

        initialized = true;

        convertColorsToRGB();

        lat = $communityMap.data('latitude');
        lng = $communityMap.data('longitude');

        var communityMappable = $communityMap.data('community-mappable');
        var searchAddress = $communityMap.data('formatted-address');
        if (communityMappable) {
            var communityName = $communityMap.data('community-name');
            communityName = communityName.split('&').join('%26');
            searchAddress = communityName + ', ' + searchAddress;
        }

        document.getElementById('communityMap').innerHTML =
            '<iframe title="Explore the Area Map" frameborder="0" style="border:0" allowfullscreen src="https://www.google.com/maps/embed/v1/place?key=' +
            $communityMap.data('key') +
            '&language=en' +
            '&q=' +
            searchAddress +
            '"></iframe>';

        // Initialize searchable map with markers as soon as the map is visible on screen
        if (hasFeaturedLocation) {
            let isIntersecting = false;
            // Map is in accordion on mobile amenity page
            const accordion = isMobile ? mapInfo.closest('.community-map-accordion') : null;
            let isVisible = !isMobile || accordion == null;

            // Only initialize searchable map if the map is visible (not hidden in an accordion) and in view
            function initVisibleSearchableMap() {
                if (isIntersecting && isVisible) {
                    initSearchableMap();
                    updatePOIsShown(false, true);
                    intersectionObserver.disconnect();
                    mutationObserver.disconnect();
                }
            }

            const intersectionOptions = {
                root: null,
                rootMargin: '20px 0px',
                threshold: 0,
            };

            // Observe when the map is scrolled into view
            const intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    isIntersecting = entry.isIntersecting;
                    initVisibleSearchableMap();
                });
            }, intersectionOptions);

            // Observe when the accordion is opened or closed
            const mutationObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.target.classList.contains('shown')) {
                        isVisible = true;
                        initVisibleSearchableMap();
                    } else {
                        isVisible = false;
                    }
                });
            });

            if (mapInfo) {
                intersectionObserver.observe(mapInfo);

                if (accordion != null) {
                    mutationObserver.observe(accordion, {
                        attributes: true,
                        attributeFilter: ['class'],
                    });
                }
            }
        }

        initSearch();
        initResultsTab();
        $featuredPois = initFeaturedPOIS();
    }

    function handleChangeMapViewButtonClick() {
        if (isMapView) {
            changeMapViewButton.innerText = 'View as Map';
        } else {
            changeMapViewButton.innerText = 'View as List';
        }
        selectedMarkerInfoBoxMobile.classList.toggle('closed');
        $mapResults.toggleClass('closed');
        $communityMap.toggleClass('closed');
        isMapView = !isMapView;
    }

    if (isMobile) {
        changeMapViewButton.addEventListener('click', () => {
            handleChangeMapViewButtonClick();
        });
    }

    init();
}

window.addEventListener('load', function () {
    initInteractiveMap();
});

if (!!window.initInteractiveMapOnLoad) {
    initInteractiveMap();
}
